function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);


  if (elementToFocus) {
    elementToFocus.focus();
  }

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo:not([data-ignore-pause])').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video:not([data-ignore-pause])').forEach((video) => {
    video.pause();
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};



class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 150);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    detailsElement.classList.add('is-closing');
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        
        detailsElement.removeAttribute('open');
        detailsElement.classList.remove('is-closing'); 
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    this.mainDetailsToggle.classList.add('is-opening');

    requestAnimationFrame(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.classList.add('menu-opening');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('is-opening');
      }, 300); 
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);



class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.addEventListener('keydown', this.handleKeyDown);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.hasAttribute('open')) {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
  
    // Trap focus within the modal dialog
    setTimeout(() => {
      const firstFocusableElement = this.querySelector('a, input, button, [tabindex]:not([tabindex="-1"])');
      trapFocus(this, firstFocusableElement);
    },300);
    
  }
  

  hide() {
    this.setAttribute("closing", "true"),
    setTimeout(() => {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    this.removeAttribute("closing");
    removeTrapFocus(this.openedBy);
    },300);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  connectedCallback() {
    this.getVariantData();
  }
  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.toggleStickyAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateVariantText();
    this.updateSoldOutState();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.toggleStickyAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateCarousel();
      
    }
  }

  updateCarousel() {
    const updateCarouselForElement = (element) => {
      if (element && this.currentVariant.featured_media) {
        element.updateCarouselImages(this.currentVariant.featured_media.id);
      }
    };
    const galleryCarousel = document.getElementById(`Gallery-carousel-${this.dataset.section}`);
    updateCarouselForElement(galleryCarousel);
    const quickViewContainer = document.querySelector('.product-modal-content');
    if (quickViewContainer) {
      const galleryCarouselQuickView = quickViewContainer.querySelector(`#Gallery-carousel-${this.dataset.section}`);
      updateCarouselForElement(galleryCarouselQuickView);
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }
  updateVariantText() {
    this.querySelectorAll('.product-form__input').forEach((item, i) => 
      item.querySelector('.form__label-value').innerHTML = this.options[i]
    );
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

updateSelectedSwatchValue({ target }) {
  const { name, value, tagName } = target;

  if (tagName === 'SELECT' && target.selectedOptions.length) {
    const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
    const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
    if (!selectedDropdownSwatchValue) return;

    if (swatchValue) {
      selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
      selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
    } else {
      selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
      selectedDropdownSwatchValue.classList.add('swatch--unavailable');
    }

    selectedDropdownSwatchValue.style.setProperty(
      '--swatch-focal-point',
      target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
    );
  } else if (tagName === 'INPUT' && target.type === 'radio') {
    const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
    if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
  }
}

updateURL() {
  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
  window.history.replaceState({}, '', `${this.dataset.url}`);
}

updateShareUrl() {
  const shareButton = document.getElementById(`Share-${this.dataset.section}`);
  if (!shareButton) return;
  shareButton.setAttribute('data-url', `${window.shopUrl}${this.dataset.url}`);
}

updateVariantInput() {
  const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  );

  productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

updateVariantStatuses() {
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(':checked').value === variant.option1
  );

  const inputWrappers = [...this.querySelectorAll('.product-form__input')];

  inputWrappers.forEach((option, index) => {
    if (index === 0) return;

    const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
    const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

    const availableOptionInputsValue = selectedOptionOneVariants
      .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
      .map((variantOption) => variantOption[`option${index + 1}`]);

    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
}

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
   
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateSoldOutState() {
    const soldOutMessageElement = document.getElementById(`sold-out-message-${this.dataset.section}`);
    const soldOutVariantNameElement = document.querySelector(`#sold-out-variant-name-${this.dataset.section}`);
    const soldOutSelectElement = document.getElementById(`ContactFormSoldout-select-${this.dataset.section}`);
    
    if (this.currentVariant && !this.currentVariant.available) {
      if (soldOutMessageElement) {
        soldOutMessageElement.classList.remove('hidden');
      }
      if (soldOutVariantNameElement) {
        soldOutVariantNameElement.textContent = this.currentVariant.title;
      }
  
      if (soldOutSelectElement) {
        const selectedVariantId = this.currentVariant.id;
        const options = soldOutSelectElement.querySelectorAll('option');
  
        options.forEach((option) => {
          const optionId = option.getAttribute('option-id');
          if (optionId == selectedVariantId) {
            option.selected = true; 
          }
        });
      }
  
    } else {
      if (soldOutMessageElement) {
        soldOutMessageElement.classList.add('hidden');
      }
      if (soldOutVariantNameElement) {
        soldOutVariantNameElement.textContent = '';
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant) {
          return;
        }
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateStickyImage(sectionId, html);
        this.updateStickyPrice(sectionId, html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        const stickyAddButtonUpdated = html.getElementById(`StickyProductSubmitButton-${sectionId}`);
        this.toggleStickyAddButton(
            stickyAddButtonUpdated ? stickyAddButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = addButton.hasAttribute('data-preorder') ? 
          window.variantStrings.preOrder : 
          window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  toggleStickyAddButton(disable = true, text, modifyClass = true) {
    const stickyProductForm = document.getElementById(`sticky-atc-${this.dataset.section}`);
    if (!stickyProductForm) return;
    const stickyAddButton = stickyProductForm.querySelector('[name="add"]');
    const stickyAddButtonText = stickyAddButton.querySelector('[name="add"] > span');
  
    if (!stickyAddButton) return;
  
    if (disable) {
      stickyAddButton.setAttribute('disabled', 'disabled');
      if (text) stickyAddButtonText.textContent = text;
    } else {
      stickyAddButton.removeAttribute('disabled');
      stickyAddButtonText.textContent = stickyAddButton.hasAttribute('data-preorder') ? 
          window.variantStrings.preOrder : 
          window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  
  updateStickyPrice(sectionId, html) {
    const stickyPriceSourceId = `price-${sectionId}-sticky`;
    const stickyPriceDestinationId = `price-${sectionId}-sticky`;
    
    const source = html.getElementById(stickyPriceSourceId);
    const destination = document.getElementById(stickyPriceDestinationId);
  
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
    }
    const price = document.getElementById(`price-${sectionId}-sticky`);
    if (price) {
      price.classList.remove('hidden');
    }
  }
  updateStickyImage(sectionId, html) {
    const sourceImage = html.getElementById(`image-${sectionId}-sticky`);
    const destinationImage = document.getElementById(`image-${sectionId}-sticky`);

    if (sourceImage && destinationImage) {
      destinationImage.src = sourceImage.src;
      destinationImage.srcset = sourceImage.srcset;
      destinationImage.sizes = sourceImage.sizes;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const buttonSticky = document.getElementById(`sticky-atc-${this.dataset.section}`);
    const addButtonSticky = buttonSticky?.querySelector('[name="add"]');
    const addButtonTextSticky = buttonSticky?.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`price-${this.dataset.section}-sticky`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (addButton && addButtonText) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    if (addButtonSticky && addButtonTextSticky) {
      addButtonTextSticky.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add('hidden');
    if (priceSticky) priceSticky.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);



class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) {
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  }
};
setScrollbarWidth();
window.addEventListener("resize", throttle(setScrollbarWidth));

class ResponsiveImage extends HTMLElement {
  constructor() {
    super();
    this.handleIntersection = this.handleIntersection.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onResize = this.onResize.bind(this);

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '10px',
      threshold: 0
    });

    this.resizeObserver = new ResizeObserver(this.onResize);
  }

  connectedCallback() {
    this.img = this.querySelector('img');
    if (this.img) {
      this.img.addEventListener('load', this.onImageLoad);
      this.img.classList.add('img-loading');

      if (this.img.hasAttribute('srcset')) {
        this.originalSrcset = this.img.getAttribute('srcset');
        this.img.removeAttribute('srcset');
        this.intersectionObserver.observe(this.img);
      }
    }
  }

  disconnectedCallback() {
    if (this.img) {
      this.img.removeEventListener('load', this.onImageLoad);
      this.intersectionObserver.unobserve(this.img);
      this.resizeObserver.unobserve(this.img);
      this.intersectionObserver.disconnect();
      this.resizeObserver.disconnect();
    }
  }

  onImageLoad() {
    this.img.classList.remove('img-loading');
    this.img.classList.add('img-loaded');
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;

        if (this.hasAttribute('data-sizes') && this.getAttribute('data-sizes') === "true") {
          this.updateSizes(img);
          this.resizeObserver.observe(img);
        }

        img.setAttribute('srcset', this.originalSrcset);
        this.intersectionObserver.unobserve(img);
      }
    });
  }

  onResize(entries) {
    entries.forEach(entry => {
      if (this.hasAttribute('data-sizes') && this.getAttribute('data-sizes') === "true") {
        this.updateSizes(entry.target);
      }
    });
  }

  updateSizes(img) {
    const width = Math.floor(img.getBoundingClientRect().width);
    img.setAttribute('sizes', `${width}px`);
  }
}

customElements.define('responsive-image', ResponsiveImage);


/**
 *  @class
 *  @function ViewportMedia
 */

if (!customElements.get('viewport-media')) {
  class ViewportMedia extends HTMLElement {
    constructor() {
      super();
      this.initObserver();
    }
  
    initObserver() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadContent();
              this.observer.unobserve(entry.target);
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px 0px 200px 0px' 
        });
  
        this.observer.observe(this);
      } else {
        this.loadContent();
      }
    }
  
    loadContent() {
      if (!this.getAttribute('loaded')) {
        const template = this.querySelector('template');
        if (template && template.content && template.content.firstElementChild) {
          const content = document.createElement('div');
          content.appendChild(template.content.firstElementChild.cloneNode(true));
    
          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, iframe'));
    
          if (deferredElement.nodeName === 'IFRAME') {
            const src = deferredElement.getAttribute('data-src');
            if (src) {
              deferredElement.setAttribute('src', src);
            }
            deferredElement.onload = () => this.removePlaceholder();
          }
          if (deferredElement.nodeName === 'VIDEO') {
            const isAutoplay = deferredElement.getAttribute('autoplay');
            const poster = deferredElement.getAttribute('poster');
            if (!isAutoplay && poster) {
              deferredElement.setAttribute('poster', poster);
            }
            deferredElement.onloadeddata = () => {
             
              this.removePlaceholder();
              if (isAutoplay) {
                deferredElement.muted = true; 
                deferredElement.play().catch(error => {
                  console.warn('Autoplay failed:', error);
                });
              }
              this.initVideoControls(deferredElement);
            };
            deferredElement.load();
          }
        }
      }
    }


    initVideoControls(video) {
      const playPauseButton = this.querySelector('.video-play-pause');
      const muteToggleButton = this.querySelector('.video-mute-toggle');
      const progressFilled = this.querySelector('.video-progress-filled');
      let updateProgress;
    
      // Handle Play/Pause Button
      if (playPauseButton) {
        playPauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            playPauseButton.classList.remove('is-play');
            playPauseButton.classList.add('is-pause');
            updateProgress = requestAnimationFrame(updateProgressBar);
          } else {
            video.pause();
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
            cancelAnimationFrame(updateProgress);
          }
        });
    
        // Reset button state on video end
        video.addEventListener('ended', () => {
          if (playPauseButton) {
            playPauseButton.classList.remove('is-pause');
            playPauseButton.classList.add('is-play');
          }
        });
      }
    
      // Handle Mute/Unmute Button
      if (muteToggleButton) {
        muteToggleButton.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.muted) {
            muteToggleButton.classList.add('is-muted');
            muteToggleButton.classList.remove('is-unmuted');
          } else {
            muteToggleButton.classList.remove('is-muted');
            muteToggleButton.classList.add('is-unmuted');
          }
        });
      }
    
      // Handle Progress Bar
      if (progressFilled) {
        const updateProgressBar = () => {
          const percentage = (video.currentTime / video.duration) * 100 || 0;
          progressFilled.style.width = `${percentage}%`;
    
          // Continue updating while playing
          updateProgress = requestAnimationFrame(updateProgressBar);
        };
    
        video.addEventListener('timeupdate', updateProgressBar);
    
        // Reset progress on end
        video.addEventListener('ended', () => {
          cancelAnimationFrame(updateProgress);
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
        });
    
        // Start progress tracking when the video can play
        video.addEventListener('canplay', () => {
          if (progressFilled) {
            progressFilled.style.width = '0%';
          }
          if (!video.paused) updateProgress = requestAnimationFrame(updateProgressBar);
        });
      }
    }
    
    
    removePlaceholder() {
      const placeholder = this.querySelector('.video-placeholder');
      if (placeholder) {
        placeholder.style.display = 'none';
      }
    }
  }
  
  customElements.define('viewport-media', ViewportMedia);
}

/**
 *  @class
 *  @function BaseCarousel
 */
class BaseCarousel extends HTMLElement {
  constructor() {
    super();
    this.slideInstance = null;
    this.isUserInteracting = false;
    this.progressRafId = null;
    this.eventBindings = [];
    this.rafId = null;
    this.arrowClickHandler = null;
    this.arrowPointerHandler = null;
    
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
    this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
  }

  connectedCallback() {
    if (!this.slideInstance) this.initCarousel();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  addShopifyEventListeners() {
    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect, { passive: true });
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { passive: true });
    }
  }

  removeShopifyEventListeners() {
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
  }

  handleBlockSelect(event) {
    const blockElement = event.target;
    const carouselElement = blockElement.closest(this.tagName.toLowerCase());
    
    if (carouselElement === this && this.slideInstance) {
      const index = parseInt(blockElement.getAttribute('data-splide-index'), 10);
      
      if (!isNaN(index)) {
        this.slideInstance.go(index);
        this.isUserInteracting = true;
        this.pauseAutoplay();
      }
    }
  }

  handleBlockDeselect(event) {
    const blockElement = event.target;
    const carouselElement = blockElement.closest(this.tagName.toLowerCase());
    
    if (carouselElement === this) {
      this.isUserInteracting = false;
      this.playAutoplay();
    }
  }

  pauseAutoplay() {
    const autoplay = this.slideInstance?.Components?.Autoplay;
    if (autoplay?.pause) {
      autoplay.pause();
    }
  }

  playAutoplay() {
    const autoplay = this.slideInstance?.Components?.Autoplay;
    if (autoplay?.play) {
      autoplay.play();
    }
  }

  initializeProgressBar() {
    const barElement = this.querySelector('.splide-carousel-progress-bar');
    if (!barElement || !this.slideInstance) return;

    const update = () => {
      if (!this.slideInstance || !this.slideInstance.Components) return;
      if (this.progressRafId) cancelAnimationFrame(this.progressRafId);

      this.progressRafId = requestAnimationFrame(() => {
        if (!this.slideInstance || !this.slideInstance.Components) return;
        const end = this.slideInstance.Components.Controller.getEnd() + 1;
        const rate = Math.min((this.slideInstance.index + 1) / end, 1);
        barElement.style.transform = `scaleX(${rate})`;
        this.progressRafId = null;
      });
    };

    update();
    this.onSlideEvent('move', update);
  }

  cleanupProgressBar() {
    if (this.progressRafId) {
      cancelAnimationFrame(this.progressRafId);
      this.progressRafId = null;
    }
  }

  onSlideEvent(eventName, handler) {
    if (!this.slideInstance) return;
    this.slideInstance.on(eventName, handler);
    this.eventBindings.push({ eventName, handler });
  }

  offSlideEvent(eventName, handler) {
    if (!this.slideInstance) return;
    this.slideInstance.off(eventName, handler);
  }

  fixParentArrow() {
    this.arrowClickHandler = (e) => {
      const arrow = e.target.closest('.splide__arrow');
      if (!arrow) return;
      
      const splideElement = arrow.closest('.splide');
      const mySplide = this.querySelector('.splide');
      
      if (splideElement !== mySplide) return;
      
      e.stopPropagation();
      e.preventDefault();
      
      const direction = arrow.classList.contains('splide__arrow--prev') ? '<' : '>';
      if (this.slideInstance) {
        this.slideInstance.go(direction);
      }
    };
  
    this.arrowPointerHandler = (e) => {
      const arrow = e.target.closest('.splide__arrow');
      if (!arrow) return;
      
      const splideElement = arrow.closest('.splide');
      const mySplide = this.querySelector('.splide');
      
      if (splideElement === mySplide) {
        e.stopPropagation();
      }
    };
  
    this.addEventListener('click', this.arrowClickHandler, { capture: true, passive: false });
    this.addEventListener('pointerdown', this.arrowPointerHandler, { capture: true, passive: true });
  }
  

  cleanupArrowHandlers() {
    if (this.arrowClickHandler) {
      this.removeEventListener('click', this.arrowClickHandler, { capture: true });
      this.arrowClickHandler = null;
    }
    
    if (this.arrowPointerHandler) {
      this.removeEventListener('pointerdown', this.arrowPointerHandler, { capture: true });
      this.arrowPointerHandler = null;
    }
  }

  cleanupSlideEvents() {
    this.eventBindings.forEach(({ eventName, handler }) => {
      this.offSlideEvent(eventName, handler);
    });
    this.eventBindings = [];
  }

  cleanupRaf() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  cleanupShopifyListeners() {
    if (Shopify?.designMode) {
      this.removeShopifyEventListeners();
    }
  }

  initCarousel() {
    throw new Error('initCarousel must be implemented');
  }

  cleanup() {
    this.cleanupSlideEvents();
    this.cleanupProgressBar();
    this.cleanupRaf();
    this.cleanupShopifyListeners();

    if (this.slideInstance) {
      this.slideInstance.destroy();
      this.slideInstance = null;
    }
  }
}

/**
 *  @class
 *  @function SplideCarousel
 */

class SplideCarousel extends BaseCarousel {
  constructor() {
    super();
    this.observer = null;
    this.videoCache = new Map();
    this.isInViewport = false;
    this.isInitialized = false;
    this.handleVideoPlayback = this.handleVideoPlayback.bind(this);
  }

  connectedCallback() {
    if (!this.slideInstance) {
      this.initObserver();
      this.initCarousel();
      this.addShopifyEventListeners();
    }
  }

  initCarousel() {
    const splideElement = this.querySelector('.splide');
    if (!splideElement) return;

    const options = splideElement.getAttribute('data-splide');
    if (!options) return;

    try {
      const parsedOptions = JSON.parse(options);
      this.slideInstance = new Splide(splideElement, parsedOptions);

      this.onSlideEvent('mounted', () => {
        this.cacheVideoElements();
        this.fixParentArrow();
        this.isInitialized = true;
        requestAnimationFrame(() => this.handleVideoPlayback());
      });

      this.onSlideEvent('moved', this.handleVideoPlayback);
      setTimeout(() => this.initializeProgressBar(), 300);
      this.slideInstance.mount();
    } catch (e) {
      console.error('Failed to initialize Splide carousel:', e);
    }
  }

  cacheVideoElements() {
    if (!this.slideInstance) return;

    const slides = this.slideInstance.Components.Elements.slides;
    this.videoCache.clear();

    slides.forEach((slide, index) => {
      if (!slide.classList.contains('is-clone')) {
        const video = slide.querySelector('.shopable-video__video');
        if (video) this.videoCache.set(index, video);
      }
    });
  }

  initObserver() {
    if (!('IntersectionObserver' in window)) {
      this.isInViewport = true;
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const wasInViewport = this.isInViewport;
        this.isInViewport = entry.isIntersecting;

        if (entry.isIntersecting) {
          this.handleVideoPlayback();
        } else if (wasInViewport) {
          this.pauseAllVideos();
        }
      });
    }, {
      rootMargin: '0px 0px -50% 0px',
      threshold: 0.1
    });

    this.observer.observe(this);
  }

  handleVideoPlayback() {
    if (!this.slideInstance || !this.isInitialized) return;

    if (this.hasAttribute('data-play-videos') && this.getAttribute('data-play-videos') === 'true') {
      return;
    }

    if (!this.isInViewport) {
      const rect = this.getBoundingClientRect();
      if (rect.top >= window.innerHeight || rect.bottom <= 0) return;
    }

    this.cleanupRaf();

    this.rafId = requestAnimationFrame(() => {
      const currentIndex = this.slideInstance.index;

      if (this.videoCache.size > 0) {
        this.videoCache.forEach((video, index) => {
          this.toggleVideo(video, currentIndex === index);
        });
      } else {
        const slides = this.slideInstance.Components.Elements.slides;
        slides.forEach((slide, index) => {
          const video = slide.querySelector('.shopable-video__video');
          if (video && !slide.classList.contains('is-clone')) {
            this.toggleVideo(video, currentIndex === index);
          } else if (video) {
            video.pause();
          }
        });
      }

      this.rafId = null;
    });
  }

  toggleVideo(video, shouldPlay) {
    if (shouldPlay) {
      if (video.paused) {
        video.play().catch(() => {});
      }
    } else if (!video.paused) {
      video.pause();
    }
  }

  pauseAllVideos() {
    this.videoCache.forEach((video) => {
      if (!video.paused) video.pause();
    });
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.videoCache.clear();
    this.isInitialized = false;
    super.cleanup();
  }
}

customElements.define('splide-carousel', SplideCarousel);


/**
 *  @class
 *  @function Slideshow
 */

if (!customElements.get('slide-show')) {
  class Slideshow extends BaseCarousel {
    constructor() {
      super();
      this.videoStates = new Map();
      this.handleVideoPlayback = this.handleVideoPlayback.bind(this);
      this.updateSlideCounter = this.updateSlideCounter.bind(this);
      this.handleFirstSlide = this.handleFirstSlide.bind(this);
      this.customizePagination = this.customizePagination.bind(this);
    }

    initCarousel() {
      const options = this.getAttribute('data-splide');
      if (!options) return;

      try {
        const parsedOptions = JSON.parse(options);
        this.slideInstance = new Splide(this, parsedOptions);

        if (this.getAttribute('data-pagination') === 'numbers') {
          this.onSlideEvent('pagination:mounted', this.customizePagination);
        }

        this.onSlideEvent('moved', this.handleVideoPlayback);
        this.onSlideEvent('moved', this.updateSlideCounter);
        this.onSlideEvent('moved', this.handleFirstSlide);
        
        this.slideInstance.mount();
        this.initializeProgressBar();
        this.updateSlideCounter(this.slideInstance.index);
        this.addShopifyEventListeners();

      } catch (e) {
        console.error('Failed to initialize Slideshow:', e);
      }
    }

    handleFirstSlide() {
      if (!this.slideInstance) return;

      this.slideInstance.Components.Elements.slides.forEach((slide) => {
        slide.classList.remove('first-slide');
      });
    }

    handleVideoPlayback() {
      if (!this.slideInstance) return;

      this.slideInstance.Components.Elements.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) {
          video.muted = true;
          slide.classList.contains('is-active') ? video.play() : video.pause();
        }
      });
    }

    updateSlideCounter(indexOrEvent) {
      if (!this.slideInstance) return;

      const newIndex = typeof indexOrEvent === 'number' ? indexOrEvent : this.slideInstance.index;
      const totalSlides = this.slideInstance.length;
      
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement) currentSlideElement.textContent = newIndex + 1;
      if (totalSlidesElement) totalSlidesElement.textContent = totalSlides;
    }

    customizePagination(data) {
      if (!data?.list || !data?.items) return;

      data.list.classList.add('splide__pagination--custom');
      data.items.forEach((item) => {
        if (item.button) {
          item.button.textContent = String(item.page + 1).padStart(2, '0');
        }
      });
    }

    cleanup() {
      this.videoStates.clear();
      super.cleanup();
    }
  }
  customElements.define('slide-show', Slideshow);
}
/**
 *  @class
 *  @function AsyncCarousel
 */

if (!customElements.get('async-carousel')) {
  class AsyncCarousel extends BaseCarousel {
    constructor() {
      super();
      this.thumbnailInstance = null;
      this.thumbnails = null;
      this.currentThumbnail = null;
      this.thumbnailClickHandlers = [];
      this.handleSlideChange = this.handleSlideChange.bind(this);
    }

    initCarousel() {
      const mainSlider = this.querySelector('[data-slider="main"]');
      const thumbnailSlider = this.querySelector('[data-slider="thumbnail"]');

      if (!mainSlider) return;

      const mainOptions = JSON.parse(mainSlider.getAttribute('data-splide') || '{}');
      this.slideInstance = new Splide(mainSlider, mainOptions);
      
      if (thumbnailSlider) {
        const thumbnailOptions = JSON.parse(thumbnailSlider.getAttribute('data-splide') || '{}');
        this.thumbnailInstance = new Splide(thumbnailSlider, thumbnailOptions);
        this.slideInstance.sync(this.thumbnailInstance);
        this.updateThumbnailARIA(thumbnailSlider);
      }

      this.onSlideEvent('mounted', () => {
        this.initThumbnails();
        this.initializeProgressBar();
        this.fixParentArrow();
      });

      this.slideInstance.mount();
      this.thumbnailInstance?.mount();
      this.addShopifyEventListeners();
    }

    initThumbnails() {
      if (!this.slideInstance) return;

      this.thumbnails = this.querySelectorAll('.thumbnail-item');
      
      this.thumbnails.forEach((thumbnail, index) => {
        const handler = () => this.slideInstance?.go(index);
        thumbnail.addEventListener('click', handler, { passive: true });
        this.thumbnailClickHandlers.push({ element: thumbnail, handler });
      });

      this.onSlideEvent('move', this.handleSlideChange);
      this.handleSlideChange();
    }

    handleSlideChange() {
      if (!this.slideInstance || !this.thumbnails) return;

      const thumbnail = this.thumbnails[this.slideInstance.index];
      
      if (thumbnail && this.currentThumbnail !== thumbnail) {
        this.currentThumbnail?.classList.remove('is-active');
        thumbnail.classList.add('is-active');
        this.currentThumbnail = thumbnail;
      }
    }

    updateThumbnailARIA(thumbnailSlider) {
      thumbnailSlider
        .querySelectorAll('.splide__slide')
        .forEach(item => item.setAttribute('role', 'group'));
    }

    cleanup() {
      this.thumbnailClickHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.thumbnailClickHandlers = [];

      this.thumbnailInstance?.destroy();
      this.thumbnailInstance = null;
      this.thumbnails = null;
      this.currentThumbnail = null;

      super.cleanup();
    }
  }
  customElements.define('async-carousel', AsyncCarousel);
}


/**
 *  @class
 *  @function GalleryCarousel
 */


if (!customElements.get('gallery-carousel')) {
  class GalleryCarousel extends HTMLElement {
    constructor() {
      super();
      this.main = null;
      this.thumbnails = null;
      this.originalSlides = [];
      this.originalThumbnails = [];
      this.rafId = null;
      this.resizeObserver = null;
      
      this.handleInactiveSlide = this.handleInactiveSlide.bind(this);
      this.handleMainActiveSlide = this.handleMainActiveSlide.bind(this);
      this.handleThumbnailActiveSlide = this.handleThumbnailActiveSlide.bind(this);
      this.updateSlideCounter = this.updateSlideCounter.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      const mainCarousel = this.querySelector('[id^="Main-Carousel"]');
      const thumbnailCarousel = this.querySelector('[id^="Thumbnail-Carousel"]');

      if (!mainCarousel || !thumbnailCarousel) {
        console.error('Main or thumbnail carousel element not found.');
        return;
      }

      this.cacheOriginalSlides(mainCarousel, thumbnailCarousel);
      
      const mainOptions = this.getCarouselOptions(mainCarousel);
      const thumbnailOptions = this.getCarouselOptions(thumbnailCarousel);
      const initialSlideIndex = this.getInitialSlideIndex();

      mainOptions.start = initialSlideIndex;
      thumbnailOptions.start = initialSlideIndex;

      this.initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions);
      this.addEventListeners();

      const enableFiltering = this.dataset.mediaGrouping === "true";
      if (enableFiltering) {
        this.initializeFiltering();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    cacheOriginalSlides(mainCarousel, thumbnailCarousel) {
      this.originalSlides = [...mainCarousel.querySelectorAll('.splide__slide')];
      this.originalThumbnails = [...thumbnailCarousel.querySelectorAll('.splide__slide')];
    }

    getCarouselOptions(carouselElement) {
      return JSON.parse(carouselElement.getAttribute('data-splide') || '{}');
    }

    getInitialSlideIndex() {
      const selectedThumbnailSlide = this.querySelector('.thumbnail-carousel .splide__slide[data-selected="true"]');
      
      if (selectedThumbnailSlide) {
        const thumbnailSlides = Array.from(this.querySelectorAll('.thumbnail-carousel .splide__slide'));
        return thumbnailSlides.indexOf(selectedThumbnailSlide);
      }
      return 0;
    }

    initializeCarousels(mainCarousel, mainOptions, thumbnailCarousel, thumbnailOptions) {
      this.main = new Splide(mainCarousel, mainOptions);
      this.thumbnails = new Splide(thumbnailCarousel, thumbnailOptions);
      
      const isVerticalThumbnail = thumbnailCarousel.getAttribute('data-thumbnail') === 'vertical';
      
      if (isVerticalThumbnail) {
        this.thumbnails.on('mounted', () => {
          const thumbnailList = thumbnailCarousel.querySelector('.splide__list');
          if (thumbnailList) {
            thumbnailList.setAttribute('role', 'tablist');
          }
          this.updateThumbnailARIA();
        });
      }

      this.main.on('mounted', () => {
        mainCarousel.classList.remove('is-initializing');
        if (this.main.index !== undefined) {
          this.updateSlideCounter(this.main.index);
        }
      });

      this.thumbnails.mount();
      this.main.sync(this.thumbnails);
      this.main.mount();
    }

    addEventListeners() {
      this.main.on('inactive', this.handleInactiveSlide);
      this.main.on('active', this.handleMainActiveSlide);
      this.main.on('moved', this.updateSlideCounter);
      this.thumbnails.on('active', this.handleThumbnailActiveSlide);
    }

    initializeFiltering() {
      const defaultFilter = this.dataset.filterSelected;
      this.filterSlides(defaultFilter);

      const radios = document.querySelectorAll(".variant-picker__color input[type='radio']");
      radios.forEach((radio) => {
        radio.addEventListener("change", this.handleVariantChange, { passive: true });
      });
    }

    handleVariantChange(event) {
      this.filterSlides(event.target.value);
    }

    updateSlideCounter(indexOrEvent) {
      const newIndex = typeof indexOrEvent === 'number' ? indexOrEvent : indexOrEvent.index;
      const totalSlides = this.main.length;
      const currentSlideElement = this.querySelector('.current-slide');
      const totalSlidesElement = this.querySelector('.total-slides');

      if (currentSlideElement && totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
        currentSlideElement.textContent = newIndex + 1;
      }
    }

    handleInactiveSlide(oldSlide) {
      const inactiveSlide = this.main.Components.Elements.slides[oldSlide.index];
      this.pauseYouTubeVideo(inactiveSlide);
    }

    handleMainActiveSlide(newSlide) {
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }
      
      const activeSlide = this.main.Components.Elements.slides[newSlide.index];
      this.handleActiveSlide(activeSlide);

      const hasProductModel = activeSlide.querySelector('product-model') !== null;
      if (this.main.Components.Drag) {
        this.main.Components.Drag.disable(hasProductModel);
      }
    }

    handleThumbnailActiveSlide(newSlide) {
      if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }
      
      const target = this.thumbnails.Components.Elements.slides[newSlide.index].getAttribute('data-target');
      const activeSlide = Array.from(this.main.Components.Elements.slides).find(
        slide => slide.getAttribute('data-media-id') === target
      );
      this.handleActiveSlide(activeSlide);
    }

    handleActiveSlide(slide) {
      if (slide && !slide.dataset.played) {
        const autoplay = this.getAttribute('data-autoplay');
        if (autoplay === 'true') {
          this.playActiveMedia(slide);
          slide.dataset.played = true;
        }
      }
    }

    playActiveMedia(activeSlide) {
      const deferredMedia = activeSlide.querySelector('.deferred-media');
      if (deferredMedia && deferredMedia.loadContent) {
        deferredMedia.loadContent(false);
      }
    }

    pauseYouTubeVideo(slide) {
      const iframe = slide.querySelector('iframe');
      if (iframe && iframe.src.includes('youtube.com')) {
        iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
      }
    }

    updateCarouselImages(mediaId) {
      if (!this.main) return;

      const mainSlides = this.main.Components.Elements.slides;
      const mainSlide = mainSlides.find(slide => slide.getAttribute('data-media-id') === mediaId.toString());

      if (mainSlide) {
        const mainIndex = mainSlides.indexOf(mainSlide);
        if (mainIndex !== -1) {
          this.main.go(mainIndex);
        }
      }
      
      if (this.hasAttribute('desktop-grid') && window.innerWidth >= 768) {
        this.scrollToGalleryItem(mediaId);
      }
    }

    scrollToGalleryItem(mediaId) {
      const galleryListsContainer = this.querySelector('.splide__gallery');
      if (!galleryListsContainer) return;

      const galleryLists = galleryListsContainer.querySelectorAll('.splide__slide');
      const targetItem = Array.from(galleryLists).find(
        item => item.getAttribute('data-media-id') === mediaId.toString()
      );

      if (targetItem) {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
        }

        this.rafId = requestAnimationFrame(() => {
          const header = document.querySelector('.header');
          const headerOffset = header ? header.offsetHeight + 16 : 16;
          const elementPosition = targetItem.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          this.rafId = null;
        });
      }
    }

    updateThumbnailARIA() {
      if (!this.thumbnails?.Components?.Elements?.list) return;
      
      const thumbnailItems = this.thumbnails.Components.Elements.list.querySelectorAll('.splide__slide');
      thumbnailItems.forEach((thumbnailItem) => {
        thumbnailItem.setAttribute('role', 'tab');
      });
    }

    filterSlides(group) {
      const mainList = this.main?.Components?.Elements?.list;
      const thumbList = this.thumbnails?.Components?.Elements?.list;
    
      if (!mainList || !thumbList) {
        console.error('Splide list element not found for main or thumbnails.');
        return;
      }
    
      mainList.innerHTML = "";
      thumbList.innerHTML = "";
    
      let slidesToShow = this.originalSlides;
      let thumbsToShow = this.originalThumbnails;
    
      if (group && group.trim() !== "") {
        const filteredSlides = this.originalSlides.filter(slide => slide.dataset.mediaGroup === group);
        const filteredThumbs = this.originalThumbnails.filter(slide => slide.dataset.mediaGroup === group);
    
        if (filteredSlides.length > 0 && filteredThumbs.length > 0) {
          slidesToShow = filteredSlides;
          thumbsToShow = filteredThumbs;
        }
      }

      const fragment1 = document.createDocumentFragment();
      const fragment2 = document.createDocumentFragment();
      
      slidesToShow.forEach(slide => fragment1.appendChild(slide));
      thumbsToShow.forEach(slide => fragment2.appendChild(slide));
      
      mainList.appendChild(fragment1);
      thumbList.appendChild(fragment2);
    
      try {
        this.main.refresh();
        this.thumbnails.refresh();
    
        if (slidesToShow.length > 0) {
          this.main.go(0);
          this.thumbnails.go(0);
          this.updateSlideCounter(0);
        } else {
          this.updateSlideCounter(-1);
          console.warn("No slides to display in the carousel after filtering.");
        }
      } catch (error) {
        console.error("Error refreshing Splide instances:", error);
      }
    
      this.observeResponsiveImages();
      this.updateThumbnailARIA();
    }

    observeResponsiveImages() {
      this.querySelectorAll('responsive-image').forEach(img => {
        if (img.img && img.intersectionObserver && img.img instanceof Element) {
          img.intersectionObserver.observe(img.img);
        }
      });
    }

    cleanup() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      const radios = document.querySelectorAll(".variant-picker__color input[type='radio']");
      radios.forEach((radio) => {
        radio.removeEventListener("change", this.handleVariantChange);
      });

      if (this.main) {
        this.main.off('inactive', this.handleInactiveSlide);
        this.main.off('active', this.handleMainActiveSlide);
        this.main.off('moved', this.updateSlideCounter);
        this.main.destroy();
        this.main = null;
      }

      if (this.thumbnails) {
        this.thumbnails.off('active', this.handleThumbnailActiveSlide);
        this.thumbnails.destroy();
        this.thumbnails = null;
      }

      this.originalSlides = [];
      this.originalThumbnails = [];
    }
  }
  
  customElements.define('gallery-carousel', GalleryCarousel);
}


/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.dataset.url) {
        console.warn('[ProductRecommendations] Missing data-url attribute');
        return;
      }
      this.fetchProducts();
    }

    async fetchProducts() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);

        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = doc.querySelector('product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim()) {
          this.renderRecommendations(recommendations.innerHTML);
        }

      } catch (error) {
        console.error('Error fetching product recommendations:', error);
      }
    }

    renderRecommendations(html) {
      this.innerHTML = html;
      this.initCarousels();
      this.classList.add('product-recommendations--loaded');
    }

    initCarousels() {
      const carousels = this.querySelectorAll('splide-carousel');
      carousels.forEach(carousel => carousel.connectedCallback?.());
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}


/**
 *  @class
 *  @function ProductCardSlider
 */
class ProductCardSlider extends BaseCarousel {
  constructor() {
    super();
    this.initObserver = null;
    this.underlineRafId = null;
    this.updateUnderline = this.updateUnderline.bind(this);
  }

  connectedCallback() {
    this.setupInitObserver();
  }

  setupInitObserver() {
    if ('IntersectionObserver' in window) {
      this.initObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.slideInstance) {
            this.initCarousel();
            this.initObserver.disconnect();
          }
        });
      }, {
        rootMargin: '200px 0px 200px 0px',
        threshold: 0
      });
      
      this.initObserver.observe(this);
    } else {
      this.initCarousel();
    }
  }

  initCarousel() {
    const splideElement = this.querySelector('.splide');
    if (!splideElement) return;

    const options = splideElement.getAttribute('data-splide');
    if (!options) return;

    try {
      const parsedOptions = JSON.parse(options);
      this.slideInstance = new Splide(splideElement, parsedOptions);

      this.onSlideEvent('mounted', () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.initializeUnderlineIndicator();
            this.fixParentArrow();
          });
        });
      });

      this.slideInstance.mount();
    } catch (e) {
      console.error('Failed to initialize Splide card:', e);
    }
  }

  initializeUnderlineIndicator() {
    const indicator = this.querySelector('.product-card-slider__underline');
    if (!indicator || !this.slideInstance) return;

    this.updateUnderline();
    
    this.onSlideEvent('move', this.updateUnderline);
    this.onSlideEvent('mounted', this.updateUnderline);
    this.onSlideEvent('resized', this.updateUnderline);
  }

  updateUnderline() {
    if (!this.slideInstance || !this.slideInstance.Components) return;
    if (this.underlineRafId) cancelAnimationFrame(this.underlineRafId);

    this.underlineRafId = requestAnimationFrame(() => {
      const track = this.slideInstance.root.querySelector('.splide__track');
      const indicator = this.querySelector('.product-card-slider__underline');
      
      if (!track || !indicator) {
        this.underlineRafId = null;
        return;
      }

      const realSlides = this.slideInstance.Components.Elements.slides.filter(
        slide => !slide.classList.contains('is-clone')
      );
      const totalSlides = realSlides.length;

      if (totalSlides === 0) {
        this.underlineRafId = null;
        return;
      }

      const index = this.slideInstance.index % totalSlides;
      const width = track.clientWidth / totalSlides;
      const offset = width * index;

      indicator.style.width = `${width}px`;
      indicator.style.transform = `translate3d(${offset}px, 0, 0)`;
      
      this.underlineRafId = null;
    });
  }

  cleanup() {
    if (this.initObserver) {
      this.initObserver.disconnect();
      this.initObserver = null;
    }

    if (this.underlineRafId) {
      cancelAnimationFrame(this.underlineRafId);
      this.underlineRafId = null;
    }

    super.cleanup();
  }
}

if (!customElements.get('product-card-slider')) {
  customElements.define('product-card-slider', ProductCardSlider);
}



class ComponentDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('.drawer-overlay');
    this.drawer = this.querySelector('.drawer-content');
    this.closeButton = this.querySelector('.close-drawer-btn');
    this.triggerButton = null;

    this.overlay.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'dialog');
    }
    document.addEventListener('keydown', this.handleKeyPress);
  }
  
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyPress);
    document.removeEventListener('focus', this.trapFocus, true);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.closeButton.focus();
    document.addEventListener('focus', this.trapFocus, true);
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('focus', this.trapFocus, true);
  
    if (this.triggerButton) {
      this.triggerButton.focus();
      this.triggerButton = null;
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  trapFocus(event) {
    if (!this.contains(event.target)) {
      event.stopPropagation();
      this.closeButton.focus();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }
}

customElements.define('component-drawer', ComponentDrawer);

class SearchDrawer extends ComponentDrawer {
  constructor() {
    super();
    this.predictiveSearch = this.querySelector('predictive-search');
    this.openTransitionEndHandler = this.openTransitionEndHandler.bind(this);
  }

  open(triggerButton) {
    this.triggerButton = triggerButton; 
    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.addEventListener('transitionend', this.openTransitionEndHandler);
    document.addEventListener('focus', this.trapFocus, true);
  }

  openTransitionEndHandler(event) {
    if (event.target === this.overlay) {
      this.removeEventListener('transitionend', this.openTransitionEndHandler);

      if (this.predictiveSearch) {
        setTimeout(() => {
          const focusElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
          if (focusElement && typeof focusElement.focus === 'function') {
            focusElement.focus();
          }
        }, 150);
      }
    }
  }

  close() {
    if (this.predictiveSearch) {
      const inputElement = this.predictiveSearch.querySelector('input:not([type="hidden"])');
      if (inputElement) {
        inputElement.value = '';
      }
      if (this.predictiveSearch.hasAttribute('open')) {
        this.predictiveSearch.removeAttribute('open');
      }
      this.predictiveSearch.setAttribute('results', 'false');
    }

    super.close();
  }
}


customElements.define('search-drawer', SearchDrawer);

class DrawerButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  connectedCallback() {
    this.targetId = this.getAttribute('data-target');
    this.targetDrawer = document.getElementById(this.targetId);
    
    this.setAttribute('tabindex', '0');
    this.setAttribute('role', 'button');
    
    if (this.targetDrawer) {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeyPress);
    } else {
      console.warn(`Drawer element with ID '${this.targetId}' does not exist.`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  }

  handleClick() {
    if (this.targetDrawer && typeof this.targetDrawer.open === 'function') {
      this.targetDrawer.open(this); 
    }
  }
}

customElements.define('drawer-button', DrawerButton);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.isFetching = false;
      this.abortController = null;
      this.cache = {};
      this.cacheDuration = 60000; // 60 seconds
      this.boundTrapFocus = this.trapFocus.bind(this);
      this.isFocusTrapped = false;
      this.loadedScripts = new Set();
      this.initElements();
      this.bindEvents();
    }

    initElements() {
      const modal = document.getElementById('product-modal');
      this.elements = {
        overlay: document.querySelector('.product-quick-view-overlay'),
        modal,
        body: document.body,
        closeButton: modal?.querySelector('.product-modal-close'),
        modalContent: modal?.querySelector('#product-modal-content')
      };
    }

    bindEvents() {
      const { overlay, closeButton, modal } = this.elements;
      this.addEventListener('click', this.onQuickViewClick.bind(this));
      this.addEventListener('keydown', this.onQuickViewKeydown.bind(this));

      if (closeButton && overlay && modal) {
        overlay.addEventListener('click', this.closeQuickView.bind(this));
        closeButton.addEventListener('click', this.closeQuickView.bind(this));
        document.addEventListener('keydown', this.onKeyDown.bind(this));
        modal.addEventListener('transitionend', this.onTransitionEnd.bind(this));
      } else {
        // Keep this error for debugging missing elements
        console.error('QuickView: Critical elements (Modal, Overlay, or Close Button) not found.');
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape' && this.elements.modal?.classList.contains('active')) {
        this.closeQuickView();
      }
    }

    onQuickViewKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.onQuickViewClick(event);
      }
    }

    trapFocus(event) {
      if (!this.isFocusTrapped || !this.elements.modal?.classList.contains('active')) return;

      if (event.key === "Tab") {
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableContent = this.elements.modal.querySelectorAll(focusableElements);
        if (focusableContent.length === 0) return;
        const firstFocusableElement = focusableContent[0];
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    }

    onTransitionEnd(event) {
      if (event.target === this.elements.modal && !this.elements.modal?.classList.contains('active')) {
        if (this.elements.modalContent) {
           this.elements.modalContent.innerHTML = '';
        }
      }
    }

    async onQuickViewClick(event) {
      event.preventDefault();

      if (this.isFetching || !this.elements.modalContent) return;

      const productHandle = this.dataset.productHandle;
      const href = this.buildProductUrl(productHandle);

      if (!href || !productHandle) return;

      this.classList.add('loading');
      this.elements.modalContent.innerHTML = '';
      this.elements.modalContent.classList.add('is-loading');

      const cachedData = this.cache[href];
      if (cachedData && (Date.now() - cachedData.timestamp < this.cacheDuration)) {
        this.renderQuickView(cachedData.content, href, productHandle);
        this.classList.remove('loading');
        setTimeout(() => {
            if (this.elements.modalContent) {
                this.elements.modalContent.classList.remove('is-loading');
            }
        }, 150);
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.isFetching = true;

      try {
        const content = await this.fetchProductContent(href, signal);
        if (!signal.aborted) {
          this.cache[href] = { content: content, timestamp: Date.now() };
          this.renderQuickView(content, href, productHandle);
        }
      } catch (error) {
         if (error.name !== 'AbortError') {
            console.error('Error fetching quick view content:', error);
            if (this.elements.modalContent) {
                this.elements.modalContent.innerHTML = '<p>Error loading product details.</p>';
            }
         }
      } finally {
        if (this.isFetching || signal?.aborted) {
            this.isFetching = false;
            this.classList.remove('loading');
            this.abortController = null;

            setTimeout(() => {
                if (this.elements.modalContent) {
                    this.elements.modalContent.classList.remove('is-loading');
                }
            }, 150);
        }
      }
    }

    buildProductUrl(productHandle) {
      const rootUrl = typeof theme?.routes?.root_url === 'string' ? theme.routes.root_url : '';
      const baseUrl = rootUrl === '/' ? '' : rootUrl;
      return `${baseUrl}/products/${productHandle}?view=quick-view`.replace('//', '/');
    }

    async fetchProductContent(url, signal) {
      const response = await fetch(url, { signal });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const contentElement = doc.querySelector('#product-modal-content');
      if (!contentElement) {
           throw new Error('Content element (#product-modal-content) not found in fetched HTML.');
      }
      return contentElement.innerHTML;
    }

    renderQuickView(content, url, productHandle) {
      if (!this.elements.modalContent) return;
      this.elements.modalContent.innerHTML = content;

      this.loadJavaScriptFiles();
      this.initializeShopifyComponents();
      this.openQuickView();
      this.dispatchQuickViewOpenEvent(url, productHandle);
    }

    loadJavaScriptFiles() {
       if (!this.elements.modalContent) return;
       this.elements.modalContent.querySelectorAll('script[src]').forEach(script => {
         const src = script.getAttribute('src');
         if (src && !this.loadedScripts.has(src) && !document.querySelector(`script[src="${src}"]`)) {
           const newScript = document.createElement('script');
           newScript.src = src;
           newScript.defer = true;
           document.head.appendChild(newScript);
           this.loadedScripts.add(src);
         }
       });
     }

    initializeShopifyComponents() {
      setTimeout(() => {
        try {
            if (typeof Shopify?.PaymentButton?.init === 'function') {
                Shopify.PaymentButton.init();
            }
            if (typeof window.ProductModel?.loadShopifyXR === 'function') {
                window.ProductModel.loadShopifyXR();
            }
        } catch (error) {
            console.error("Error initializing Shopify components:", error);
        }
      }, 200);
    }

    openQuickView() {
      const { body, modal, closeButton } = this.elements;
      if (!body || !modal) return;

      body.classList.add('quickview-open');
      modal.classList.add('active');

      setTimeout(() => {
          closeButton?.focus();
      }, 50);

      if (!this.isFocusTrapped) {
          document.addEventListener('keydown', this.boundTrapFocus);
          this.isFocusTrapped = true;
      }
    }

    closeQuickView() {
      const { body, modal } = this.elements;
       if (!body || !modal) return;

      body.classList.remove('quickview-open');
      modal.classList.remove('active');

      if (this.isFocusTrapped) {
          document.removeEventListener('keydown', this.boundTrapFocus);
          this.isFocusTrapped = false;
      }

       if (this.abortController) {
           this.abortController.abort();
       }
    }

    dispatchQuickViewOpenEvent(url, productHandle) {
      document.dispatchEvent(new CustomEvent('quick-view:open', {
        bubbles: true,
        detail: { productUrl: url, productHandle }
      }));
    }
  }

  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function CollapsibleDetails
 */

if (!customElements.get('collapsible-details')) {
  class CollapsibleDetails extends HTMLElement {
    constructor() {
      super();
      this.toggleContent = this.toggleContent.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.updateHeight = this.updateHeight.bind(this);
      this.setResponsiveState = this.setResponsiveState.bind(this);
      this.isAnimating = false;
    }

    connectedCallback() {
      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.querySelector('summary');
      this.contentEl = this.querySelector('.collapsible__content');
      this.contentInnerEl = this.querySelector('.collapsible__content-inner');
    
      if (!this.detailsEl || !this.summaryEl || !this.contentEl) {
        return;
      }
    
      this.wrapContent();
      this.setupInitialState();
      this.addEventListeners();
    
      // Setup ResizeObserver to handle content size changes
      if (this.contentInnerEl) {
        this.resizeObserver = new ResizeObserver(this.updateHeight);
        this.resizeObserver.observe(this.contentInnerEl);
      }
    
      if (this.detailsEl.dataset.responsive === 'true') {
        this.setResponsiveState();
      }
    
      this.mutationObserver = new MutationObserver(this.updateContentHeight.bind(this));
      if (this.contentInnerEl) {
        this.mutationObserver.observe(this.contentInnerEl, { 
          childList: true, 
          subtree: true, 
          characterData: true 
        });
      }
    }


    wrapContent() {
      if (!this.contentEl || !this.contentEl.parentElement) {
        return;
      }
    
      if (this.contentEl.parentElement.classList.contains('collapsible__content-wrapper')) {
        this.contentWrapper = this.contentEl.parentElement;
        return;
      }
    
      this.contentWrapper = document.createElement('div');
      this.contentWrapper.className = 'collapsible__content-wrapper';
    
      this.contentEl.parentNode.insertBefore(this.contentWrapper, this.contentEl);
      this.contentWrapper.appendChild(this.contentEl);
    }
    

    setupInitialState() {
      if (!this.detailsEl) {
        return;
      }
    
      if (this.detailsEl.hasAttribute('open')) {
        this.contentWrapper.style.height = 'auto';
        this.contentEl.style.transform = 'translateY(0)';
        this.detailsEl.classList.add('is-open');
      } else {
        this.contentWrapper.style.height = '0';
        this.contentEl.style.transform = 'translateY(16px)';
      }
    }


    addEventListeners() {
      if (!this.summaryEl || !this.contentWrapper) {
        return;
      }
    
      this.summaryEl.addEventListener('click', this.toggleContent);
      this.contentWrapper.addEventListener('transitionend', this.onTransitionEnd);
    }

    toggleContent(event) {
      event.preventDefault();
      if (this.isAnimating) {
        this.pendingState = !this.detailsEl.open;
        return;
      }
      
      this[this.detailsEl.open ? 'closeContent' : 'openContent']();
    }

    openContent() {
      this.isAnimating = true;
      this.detailsEl.open = true;
      
      requestAnimationFrame(() => {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = '0';
        this.contentEl.style.transform = 'translateY(16px)';
        
        requestAnimationFrame(() => {
          this.detailsEl.classList.add('is-open');
          this.contentWrapper.style.height = `${height}px`;
          this.contentEl.style.transform = 'translateY(0)';
        });
      });
    }

    closeContent() {
      this.isAnimating = true;
      
      requestAnimationFrame(() => {
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
        
        requestAnimationFrame(() => {
          this.detailsEl.classList.remove('is-open');
          this.contentWrapper.style.height = '0';
          this.contentEl.style.transform = 'translateY(16px)';
        });
      });
    }

    onTransitionEnd(event) {
      if (event.propertyName !== 'height' || event.target !== this.contentWrapper) return;
      
      this.isAnimating = false;
      
      if (!this.detailsEl.classList.contains('is-open')) {
        this.detailsEl.open = false;
      } else {
        this.contentWrapper.style.height = 'auto';
      }

      if (this.pendingState !== undefined) {
        this[this.pendingState ? 'openContent' : 'closeContent']();
        this.pendingState = undefined;
      }
    }

    updateHeight() {
      if (this.detailsEl.open && !this.isAnimating) {
        this.contentWrapper.style.height = 'auto';
        const height = this.contentWrapper.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }
    updateContentHeight() {
      if (this.detailsEl.open) {
        const height = this.contentEl.scrollHeight;
        this.contentWrapper.style.height = `${height}px`;
      }
    }

    disconnectedCallback() {
      if (this.summaryEl) {
        this.summaryEl.removeEventListener('click', this.toggleContent);
      }
    
      if (this.contentWrapper) {
        this.contentWrapper.removeEventListener('transitionend', this.onTransitionEnd);
      }
    
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
    setResponsiveState() {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
      if (isMobile && this.detailsEl.open) {
        return;
      }
    
      this.detailsEl.open = !isMobile;
      this.detailsEl.classList.toggle('is-open', !isMobile);
    
      if (isMobile) {
        this.contentWrapper.style.height = '0';
      } else {
        this.contentWrapper.style.height = 'auto';
        this.contentEl.style.transform = 'translateY(0)';
        
        setTimeout(() => {
          const height = this.contentEl.scrollHeight;
          this.contentWrapper.style.height = `${height}px`;
        }, 0);
      }
    }
    
    
  }

  customElements.define('collapsible-details', CollapsibleDetails);
}

// Use a debounced resize handler for better performance
function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

window.addEventListener('resize', debounce(() => {
  document.querySelectorAll('collapsible-details details[data-responsive="true"]')
    .forEach(details => details.closest('collapsible-details').setResponsiveState());
}));

/**
 *  @class
 *  @function TabsComponent
 */

if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabsHeader = this.querySelector('.tabs-header');
      this.tabsContent = this.querySelector('.tabs-content');
      this.tabActiveIndicator = this.querySelector('.indicator');

      this.tabsHeader.addEventListener('click', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.activateTab(e.target);
        }
      });

      this.tabsHeader.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('tab-button')) {
          this.handleKeyDown(e);
        }
      });

      this.activateTab(this.tabsHeader.querySelector('.tab-button'));

      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      }
    }

    activateTab(tab) {
      const tabIndex = tab.getAttribute('data-tab');

      this.tabsHeader.querySelectorAll('.tab-button').forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive);
        t.setAttribute('tabindex', isActive ? '0' : '-1'); 
      });

      this.tabsContent.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.toggle('active', content.getAttribute('id') === tabIndex);
      });

      const tabRect = tab.getBoundingClientRect();
      const tabsHeaderRect = this.tabsHeader.getBoundingClientRect();
      const offsetLeft = tabRect.left - tabsHeaderRect.left;

      this.tabsHeader.style.setProperty('--indicator-width', `${tabRect.width}px`);
      this.tabsHeader.style.setProperty('--indicator-offset', `${offsetLeft}px`);
    }

    handleKeyDown(e) {
      const key = e.key;
      const currentTab = e.target;
      let newTab;

      switch (key) {
        case 'ArrowRight':
          newTab = currentTab.nextElementSibling || this.tabsHeader.firstElementChild;
          break;
        case 'ArrowLeft':
          newTab = currentTab.previousElementSibling || this.tabsHeader.lastElementChild;
          break;
        case 'Enter':
        case 'Space':  
          this.activateTab(currentTab);
          return;
      }

      if (newTab && newTab.classList.contains('tab-button')) {
        e.preventDefault();
        newTab.focus(); 
      }
    }

    handleBlockSelect(e) {
      const blockId = e.detail.blockId;
      const tabToActivate = this.tabsHeader.querySelector(`[data-tab="tab-${blockId}"]`);
      if (tabToActivate) {
        this.activateTab(tabToActivate);
      }
    }
  }

  customElements.define('tabs-component', TabsComponent);
}

/**
 *  @class
 *  @function CardProductSwatch
 */

if (!customElements.get('card-product-swatch')) {
  class CardProductSwatch extends HTMLElement {
    constructor() {
      super();
      this.slideInstance = null;
      this.clickHandlers = new Map();
    }

    connectedCallback() {
      this.swatchButtons = this.querySelectorAll('.swatch-button');
      this.image = this.closest('.card-product')?.querySelector('.product-first-image img');
      this.link = this.closest('.card-product')?.querySelector('.product-link');
      this.sliderCarousel = this.hasAttribute('data-slider') 
        ? (this.closest('.card-product')?.querySelector('product-card-slider') ||
           this.parentElement?.querySelector('product-card-slider'))
        : null;

      this.swatchButtons.forEach((button) => {
        const handler = (e) => this.handleSwatchClick(e, button);
        this.clickHandlers.set(button, handler);
        button.addEventListener('click', handler);
      });
    }

    disconnectedCallback() {
      this.clickHandlers.forEach((handler, button) => {
        button.removeEventListener('click', handler);
      });
      this.clickHandlers.clear();
    }

    async handleSwatchClick(e, button) {
      e.preventDefault();
      const imageSrc = button.dataset.variantImageSrc || button.dataset.src;
      if (!imageSrc) return;

      this.updateActiveButton(button);

      if (!this.hasAttribute('data-slider')) {
        this.updateProductImage(button);
        this.updateProductLink(button);
        return;
      }

      await this.ensureSlideInitialized();
      if (!this.slideInstance) return;

      const slideIndex = this.findSlideIndexByImage(imageSrc);
      if (slideIndex !== -1) this.slideInstance.go(slideIndex);
    }

    async ensureSlideInitialized() {
      if (this.slideInstance || !this.sliderCarousel) return;

      return new Promise((resolve) => {
        const check = () => {
          if (this.sliderCarousel.slideInstance) {
            this.slideInstance = this.sliderCarousel.slideInstance;
            resolve();
          } else {
            requestAnimationFrame(check);
          }
        };
        check();
      });
    }

    findSlideIndexByImage(imageSrc) {
      if (!this.slideInstance) return -1;

      const slides = this.slideInstance.Components.Elements.slides.filter(
        slide => !slide.classList.contains('is-clone')
      );
      
      const normalize = (url) => url?.split('?')[0].toLowerCase().trim() || '';
      const normalizedSearch = normalize(imageSrc);

      for (let i = 0; i < slides.length; i++) {
        const slideImageSrc = slides[i].dataset.variantImageSrc;
        if (slideImageSrc && normalize(slideImageSrc) === normalizedSearch) return i;
      }

      for (let i = 0; i < slides.length; i++) {
        const slideImageSrc = slides[i].dataset.variantImageSrc;
        if (slideImageSrc) {
          const normalized = normalize(slideImageSrc);
          if (normalized.includes(normalizedSearch) || normalizedSearch.includes(normalized)) 
            return i;
        }
      }

      for (let i = 0; i < slides.length; i++) {
        const img = slides[i].querySelector('img');
        if (img?.src && normalize(img.src).includes(normalizedSearch)) return i;
      }

      return -1;
    }

    updateActiveButton(button) {
      this.swatchButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
    }

    updateProductImage(button) {
      if (!this.image) return;
      const srcset = button.getAttribute('data-srcset');
      const src = button.getAttribute('data-src');
      if (srcset) this.image.srcset = srcset;
      if (src) this.image.src = src;
    }

    updateProductLink(button) {
      const link = button.getAttribute('data-link');
      if (this.link && link) this.link.href = link;
    }
  }

  customElements.define('card-product-swatch', CardProductSwatch);
}



/**
 *  @class
 *  @function CountdownTimer
 */

if (!customElements.get('count-down')) {
  class CountdownTimer extends HTMLElement {
      constructor() {
          super();
          this.endTime = new Date(this.getAttribute('data-timer')).getTime();
          
          // Cache DOM elements
          this.daysElem = this.querySelector('li[data-value="days"] .countdown-day');
          this.hoursElem = this.querySelector('li[data-value="hours"] .countdown-hour');
          this.minutesElem = this.querySelector('li[data-value="minutes"] .countdown-minute');
          this.secondsElem = this.querySelector('li[data-value="seconds"] .countdown-second');
      }

      connectedCallback() {
          this.startCountdown();
      }

      startCountdown() {
          const updateCountdown = () => {
              const now = new Date().getTime();
              const distance = this.endTime - now;

              if (distance < 0) {
                  this.displayTime(0, 0, 0, 0);
                  return;
              }

              const days = Math.floor(distance / (1000 * 60 * 60 * 24));
              const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((distance % (1000 * 60)) / 1000);

              this.displayTime(days, hours, minutes, seconds);

              // Request the next frame
              requestAnimationFrame(updateCountdown);
          };

          updateCountdown(); // Start the countdown
      }

      displayTime(days, hours, minutes, seconds) {
          this.daysElem.textContent = days;
          this.hoursElem.textContent = hours;
          this.minutesElem.textContent = minutes;
          this.secondsElem.textContent = seconds;
      }
  }

  customElements.define('count-down', CountdownTimer);
}

(function() {
  function getAbsoluteTop(element) {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(event) {
      if (event.target.matches('[data-anchor]')) {
        event.preventDefault();
        
        const href = event.target.getAttribute('href');
        if (!href || href === '#') return;
        
        const targetId = href.replace('#', '');
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          const targetPosition = getAbsoluteTop(targetSection) - headerHeight;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  }

  // Init when DOM is ready
  document.addEventListener('DOMContentLoaded', initSmoothScroll);
})();

if (!customElements.get('show-more-toggle')) {
  customElements.define(
    'show-more-toggle',
    class ShowMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-show-more-content]');
        this.button = this.querySelector('button');
        this.showMoreText = this.querySelector('.label-show-more');
        this.showLessText = this.querySelector('.label-show-less');

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        this.content.classList.toggle('content-truncated');
        this.showMoreText.classList.toggle('hidden');
        this.showLessText.classList.toggle('hidden');
      }
    }
  );
}










// ArtsGalleri Border / No Border — automatic dual mode
// MODE 1: In this store setup, the image marked #noborder-hidden is the
//         dedicated BORDER preview image, while the normal first artwork image
//         is the NO BORDER preview. Switching is done instantly from cache.
// MODE 2: If no separate #noborder-hidden Border image exists, the normal
//         artwork is used and Border receives equal code padding on all sides.
// Both modes keep the same permanent outer poster dimensions and preserve
// normal thumbnails, arrows, swipe, zoom, lightbox, size, border and frame behaviour.

(function () {
  "use strict";

  const GALLERY_SELECTOR = '[id^="MediaGallery-"]';
  const STYLE_ID = "ag-border-preview-styles-v15";

  const BORDER_ON_VALUES = [
    "border",
    "margin",
    "white border",
    "with border",
    "vit marginal",
    "grans",
    "grans med kant",
    "grense",
    "kant"
  ];

  const BORDER_OFF_VALUES = [
    "",
    "no border",
    "no-border",
    "without border",
    "none",
    "ingen grans",
    "utan grans",
    "ingen grense",
    "ingen kant",
    "ingen marginal"
  ];

  const SIZE_TO_MARGIN = {
    "21x30": "1.5 cm",
    "30x40": "2 cm",
    "40x50": "3 cm",
    "50x70": "4 cm",
    "60x90": "4.5 cm",
    "70x100": "5 cm"
  };

  const SIZE_TO_PADDING = {
    "21x30": 25,
    "30x40": 35,
    "40x50": 45,
    "50x70": 55,
    "60x90": 58,
    "70x100": 60
  };

  function normalize(value) {
    let output = (value || "").toString().trim().toLowerCase();

    if (typeof output.normalize === "function") {
      output = output.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    return output.replace(/\s+/g, " ");
  }

  function escapeHtml(value) {
    return (value || "")
      .toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function extractSizeKey(value) {
    const normalizedValue = normalize(value).replace(/×/g, "x");
    const match = normalizedValue.match(/(\d+)\s*x\s*(\d+)/);

    return match ? `${match[1]}x${match[2]}` : "";
  }


  function hasNoBorderHiddenMarker(value) {
    const normalizedValue = normalize(value);

    return (
      normalizedValue.includes("#noborder-hidden") ||
      normalizedValue.includes("noborder-hidden") ||
      normalizedValue.includes("no-border-hidden")
    );
  }

  function cleanHiddenAlt(value) {
    return (value || "")
      .toString()
      .replace(/#?noborder-hidden/gi, "")
      .replace(/#?no-border-hidden/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function toPositiveNumber(value) {
    const number = parseFloat(value || "");
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function getSourceCandidatesFromSrcset(srcset) {
    if (!srcset) return [];

    return srcset
      .toString()
      .split(",")
      .map(function (candidate) {
        const parts = candidate.trim().split(/\s+/);
        const url = parts[0] || "";
        const descriptor = parts[1] || "";
        let width = 0;

        if (/\d+w$/.test(descriptor)) {
          width = parseInt(descriptor, 10) || 0;
        } else if (/\d+(?:\.\d+)?x$/.test(descriptor)) {
          width = Math.round((parseFloat(descriptor) || 0) * 100000);
        }

        return { url: url, width: width };
      })
      .filter(function (item) {
        return Boolean(item.url);
      });
  }

  function getSourceFromSrcset(srcset) {
    const candidates = getSourceCandidatesFromSrcset(srcset);
    if (!candidates.length) return "";

    candidates.sort(function (first, second) {
      return second.width - first.width;
    });

    return candidates[0].url || "";
  }

  function getBestImageUrl(image) {
    if (!image) return "";

    return (
      getSourceFromSrcset(
        image.getAttribute("srcset") || image.getAttribute("data-srcset")
      ) ||
      image.currentSrc ||
      image.getAttribute("src") ||
      image.getAttribute("data-src") ||
      ""
    );
  }

  function normalizeUrlIdentity(value) {
    if (!value) return "";

    let output = value.toString().trim();

    try {
      const url = new URL(output, window.location.href);
      output = url.pathname || output;
    } catch (error) {
      output = output.split("?")[0].split("#")[0];
    }

    output = output
      .replace(/^https?:\/\/[^/]+/i, "")
      .replace(/\?.*$/, "")
      .replace(/#.*$/, "")
      .replace(/_(\d+)x(\d+)?(_crop_[^./]+)?(?=\.)/i, "")
      .replace(/_(\d+)x(?=\.)/i, "")
      .replace(/\/(?:cdn\/shop\/)?(?:files|products)\//i, "/")
      .toLowerCase();

    try {
      output = decodeURIComponent(output);
    } catch (error) {}

    return output;
  }

  function collectUrlIdentitiesFromValue(value) {
    if (!value) return [];

    const output = [];
    const text = value.toString();

    if (text.includes(",") || /\s+\d+w(?:\s|$)/.test(text)) {
      getSourceCandidatesFromSrcset(text).forEach(function (candidate) {
        const identity = normalizeUrlIdentity(candidate.url);
        if (identity) output.push(identity);
      });
    } else {
      const identity = normalizeUrlIdentity(text);
      if (identity) output.push(identity);
    }

    return output;
  }

  function collectSourceIdentities(sourceData) {
    if (!sourceData) return [];

    let identities = [];

    [
      sourceData.src,
      sourceData.srcset,
      sourceData.dataSrc,
      sourceData.dataSrcset
    ].forEach(function (value) {
      identities = identities.concat(collectUrlIdentitiesFromValue(value));
    });

    (sourceData.pictureSources || []).forEach(function (source) {
      identities = identities.concat(
        collectUrlIdentitiesFromValue(source.srcset || source.dataSrcset || "")
      );
    });

    return identities.filter(function (identity, index, array) {
      return identity && array.indexOf(identity) === index;
    });
  }

  function collectImageIdentities(image) {
    if (!image) return [];

    let identities = [];

    [
      image.currentSrc,
      image.getAttribute("src"),
      image.getAttribute("data-src"),
      image.getAttribute("srcset"),
      image.getAttribute("data-srcset")
    ].forEach(function (value) {
      identities = identities.concat(collectUrlIdentitiesFromValue(value));
    });

    const picture = image.closest("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach(function (source) {
        identities = identities.concat(
          collectUrlIdentitiesFromValue(
            source.getAttribute("srcset") || source.getAttribute("data-srcset") || ""
          )
        );
      });
    }

    return identities.filter(function (identity, index, array) {
      return identity && array.indexOf(identity) === index;
    });
  }

  function sourceMatchesSource(firstSource, secondSource) {
    const firstIdentities = collectSourceIdentities(firstSource);
    const secondIdentities = collectSourceIdentities(secondSource);

    return firstIdentities.some(function (identity) {
      return secondIdentities.includes(identity);
    });
  }

  function imageMatchesSource(image, sourceData) {
    const imageIdentities = collectImageIdentities(image);
    const sourceIdentities = collectSourceIdentities(sourceData);

    return imageIdentities.some(function (identity) {
      return sourceIdentities.includes(identity);
    });
  }

  function scoreImage(image) {
    if (!image) return 0;

    const rectangle = image.getBoundingClientRect
      ? image.getBoundingClientRect()
      : { width: 0, height: 0 };

    const naturalWidth = image.naturalWidth || toPositiveNumber(image.getAttribute("width"));
    const naturalHeight = image.naturalHeight || toPositiveNumber(image.getAttribute("height"));

    return Math.max(
      rectangle.width * rectangle.height,
      naturalWidth * naturalHeight,
      1
    );
  }

  function getPictureSources(image) {
    const picture = image ? image.closest("picture") : null;
    if (!picture) return [];

    return Array.from(picture.querySelectorAll("source")).map(function (source) {
      return {
        srcset: source.getAttribute("srcset") || "",
        dataSrcset: source.getAttribute("data-srcset") || "",
        sizes: source.getAttribute("sizes") || "",
        media: source.getAttribute("media") || "",
        type: source.getAttribute("type") || ""
      };
    });
  }

  function captureImageSource(image, mode) {
    if (!image) return null;

    const srcset = image.getAttribute("srcset") || image.getAttribute("data-srcset") || "";
    const src = getBestImageUrl(image) || getSourceFromSrcset(srcset);

    if (!src && !srcset) return null;

    return {
      mode: mode || "image",
      src: src,
      srcset: srcset,
      sizes: image.getAttribute("sizes") || "",
      dataSrc: image.getAttribute("data-src") || "",
      dataSrcset: image.getAttribute("data-srcset") || "",
      width: image.naturalWidth || toPositiveNumber(image.getAttribute("width")),
      height: image.naturalHeight || toPositiveNumber(image.getAttribute("height")),
      alt: cleanHiddenAlt(image.getAttribute("alt") || image.alt || ""),
      pictureSources: getPictureSources(image),
      key: [mode || "image", src, srcset].join("|")
    };
  }

  function buildManualSource(options) {
    if (!options || !options.src) return null;

    const src = options.src || "";
    const srcset = options.srcset || "";

    return {
      mode: options.mode || "manual",
      src: src,
      srcset: srcset,
      sizes: options.sizes || "",
      dataSrc: src,
      dataSrcset: srcset,
      width: toPositiveNumber(options.width),
      height: toPositiveNumber(options.height),
      alt: cleanHiddenAlt(options.alt || ""),
      pictureSources: [],
      key: [options.mode || "manual", src, srcset].join("|")
    };
  }

  function setOrRemoveAttribute(element, attribute, value) {
    if (!element) return;

    if (value) {
      element.setAttribute(attribute, value);
    } else {
      element.removeAttribute(attribute);
    }
  }

  function applyImageSource(image, sourceData) {
    if (!image || !sourceData || (!sourceData.src && !sourceData.srcset)) return;

    const sourceKey = sourceData.key || [sourceData.src, sourceData.srcset].join("|");
    if (image.dataset.agCurrentBorderSourceKey === sourceKey) return;

    const picture = image.closest("picture");
    const sources = picture ? Array.from(picture.querySelectorAll("source")) : [];
    const fallbackSrcset = sourceData.srcset || sourceData.src;

    sources.forEach(function (source, index) {
      const savedSource = sourceData.pictureSources && sourceData.pictureSources[index];
      const nextSrcset = savedSource ? savedSource.srcset : fallbackSrcset;
      const nextDataSrcset = savedSource ? savedSource.dataSrcset : fallbackSrcset;
      const nextSizes = savedSource ? savedSource.sizes : sourceData.sizes;

      setOrRemoveAttribute(source, "srcset", nextSrcset);
      setOrRemoveAttribute(source, "data-srcset", nextDataSrcset);
      setOrRemoveAttribute(source, "sizes", nextSizes);
    });

    setOrRemoveAttribute(image, "sizes", sourceData.sizes);
    setOrRemoveAttribute(image, "srcset", fallbackSrcset);
    setOrRemoveAttribute(image, "data-srcset", fallbackSrcset);

    if (sourceData.src) {
      image.setAttribute("src", sourceData.src);
      image.setAttribute("data-src", sourceData.src);
    }

    if (sourceData.width) image.setAttribute("width", String(Math.round(sourceData.width)));
    if (sourceData.height) image.setAttribute("height", String(Math.round(sourceData.height)));
    if (sourceData.alt) image.setAttribute("alt", sourceData.alt);

    image.dataset.agCurrentBorderSourceKey = sourceKey;
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      ${GALLERY_SELECTOR} [data-border-base-slide="true"] {
        --ag-border-preview-padding: 19px;
        --ag-border-preview-speed: 420ms;
        --ag-border-preview-easing: cubic-bezier(0.22, 1, 0.36, 1);
      }

      ${GALLERY_SELECTOR} [data-border-base-slide="true"]
      .ag-border-preview-surface {
        position: relative !important;
        width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        background: transparent !important;
        aspect-ratio: auto !important;
        padding: 0 !important;
      }

      ${GALLERY_SELECTOR} [data-border-base-slide="true"]
      .ag-border-preview-surface.ag-border-preview-geometry {
        height: var(--ag-border-preview-surface-height) !important;
        min-height: 0 !important;
        max-height: none !important;
      }

      ${GALLERY_SELECTOR} [data-border-base-slide="true"]
      .ag-border-preview-surface.ag-border-preview-geometry::before,
      ${GALLERY_SELECTOR} [data-border-base-slide="true"]
      .ag-border-preview-surface.ag-border-preview-geometry::after {
        content: none !important;
        display: none !important;
        padding: 0 !important;
      }

      ${GALLERY_SELECTOR} [data-border-base-slide="true"]
      .ag-border-preview-image {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        object-fit: contain !important;
        object-position: center center !important;
        background-color: transparent !important;
        opacity: 1 !important;
        visibility: visible !important;
        animation: none !important;
        transform: translateZ(0) !important;
        backface-visibility: hidden !important;
        -webkit-backface-visibility: hidden !important;
      }

      /* No transition is allowed during the first setup. */
      ${GALLERY_SELECTOR}:not(.ag-border-preview-ready)
      [data-border-base-slide="true"] .ag-border-preview-surface,
      ${GALLERY_SELECTOR}:not(.ag-border-preview-ready)
      [data-border-base-slide="true"] .ag-border-preview-image {
        transition: none !important;
      }

      /*
        The outer poster box and the artwork source must never zoom, shrink,
        grow, or animate when Border / No Border is changed. The white border
        is applied inside the existing poster dimensions.
      */
      ${GALLERY_SELECTOR}.ag-border-preview-ready
      [data-border-base-slide="true"] .ag-border-preview-surface,
      ${GALLERY_SELECTOR}.ag-border-preview-ready
      [data-border-base-slide="true"] .ag-border-preview-image {
        transition: none !important;
      }

      ${GALLERY_SELECTOR}.ag-border-layout-syncing
      [data-border-base-slide="true"] .ag-border-preview-surface,
      ${GALLERY_SELECTOR}.ag-border-layout-syncing
      [data-border-base-slide="true"] .ag-border-preview-image {
        transition: none !important;
      }

      /*
        FALLBACK MODE:
        When the product does not contain a separate uploaded Border / No Border
        image pair, Border is created inside the existing poster dimensions.
        The same padding value is used on all four sides.
      */
      ${GALLERY_SELECTOR}:not(.ag-real-border-image-mode)
      [data-border-base-slide="true"].ag-border-preview-active
      .ag-border-preview-image {
        padding:
          var(--ag-border-preview-padding)
          var(--ag-border-preview-padding)
          var(--ag-border-preview-padding)
          var(--ag-border-preview-padding) !important;
        border: 0 !important;
        background-color: #ffffff !important;
        object-fit: fill !important;
        object-position: center center !important;
      }

      ${GALLERY_SELECTOR}:not(.ag-real-border-image-mode)
      [data-border-base-slide="true"]:not(.ag-border-preview-active)
      .ag-border-preview-image {
        padding: 0 !important;
        border: 0 !important;
        background-color: transparent !important;
        object-fit: contain !important;
        object-position: center center !important;
      }

      /*
        UPLOADED-IMAGE MODE:
        In this store the #noborder-hidden media is the dedicated Border image.
        The normal first/main artwork is the No Border image. No CSS padding is
        added when that real uploaded pair is available.
      */
      ${GALLERY_SELECTOR}.ag-real-border-image-mode
      [data-border-base-slide="true"].ag-border-preview-active
      .ag-border-preview-image,
      ${GALLERY_SELECTOR}.ag-real-border-image-mode
      [data-border-base-slide="true"]:not(.ag-border-preview-active)
      .ag-border-preview-image {
        padding: 0 !important;
        border: 0 !important;
        background-color: transparent !important;
        object-fit: contain !important;
        object-position: center center !important;
      }

      /*
        Keep the original gallery image clickable beneath the visual swap.
        The uploaded Border / No Border image above it never blocks gallery
        navigation, zoom, lightbox, arrows, or swipe behaviour.
      */
      ${GALLERY_SELECTOR}.ag-real-border-image-mode
      [data-border-base-slide="true"] .ag-border-original-hidden {
        opacity: 0 !important;
        visibility: visible !important;
        pointer-events: auto !important;
      }

      ${GALLERY_SELECTOR} .ag-real-border-swap-image {
        position: absolute !important;
        inset: 0 !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        object-fit: contain !important;
        object-position: center center !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        z-index: 5 !important;
        transition: none !important;
      }

      ${GALLERY_SELECTOR}
      .ag-real-border-swap-image.is-active:not(.is-loading) {
        opacity: 1 !important;
        visibility: visible !important;
      }

      ${GALLERY_SELECTOR}
      .ag-real-border-swap-image.is-loading {
        opacity: 0 !important;
        visibility: hidden !important;
      }

      /*
        Do not display:none the #noborder-hidden media node here.
        Hiding Splide slides can break thumbnail/arrow indexing. The marker
        identifies the special Border preview source; normal gallery navigation
        must continue to use the regular first/main slide.
      */
      ${GALLERY_SELECTOR} .ag-noborder-hidden-media {
        display: revert !important;
      }

      /*
        Only remove the option-card CSS inset when a real uploaded Border image
        exists. In fallback mode the card may keep its normal border preview.
      */
      [data-border-picker][data-ag-real-border-image-mode="true"]
      .ag-border-card__thumb.is-with-border,
      [data-option-role="border"][data-ag-real-border-image-mode="true"]
      .ag-border-card__thumb.is-with-border {
        padding: 0 !important;
        border: none !important;
        background: transparent !important;
      }

      [data-border-picker] label.ag-border-card,
      [data-option-role="border"] label.ag-border-card {
        position: relative !important;
        cursor: pointer !important;
        pointer-events: auto !important;
        touch-action: manipulation !important;
      }

      [data-border-picker] label.ag-border-card .ag-border-card__content,
      [data-option-role="border"] label.ag-border-card .ag-border-card__content {
        display: contents !important;
      }

      [data-border-picker] label.ag-border-card .ag-border-card__content *,
      [data-option-role="border"] label.ag-border-card .ag-border-card__content * {
        pointer-events: none !important;
      }

      /*
        Legacy size-transition rules retained only so an older cached clone
        can be hidden and removed safely. The current script never creates one.
      */
      ${GALLERY_SELECTOR}.ag-size-transition-active {
        position: relative !important;
      }

      ${GALLERY_SELECTOR} .ag-size-change-freeze {
        position: absolute !important;
        display: block !important;
        margin: 0 !important;
        min-width: 0 !important;
        max-width: none !important;
        min-height: 0 !important;
        max-height: none !important;
        transform: none !important;
        pointer-events: none !important;
        user-select: none !important;
        overflow: visible !important;
        opacity: 1 !important;
        z-index: 90 !important;
        transition: opacity 180ms ease !important;
        will-change: opacity !important;
      }

      ${GALLERY_SELECTOR} .ag-size-change-freeze.is-releasing {
        opacity: 0 !important;
      }

      ${GALLERY_SELECTOR} .ag-size-change-freeze * {
        pointer-events: none !important;
      }

      /*
        Safety cleanup for older cached versions of this file. The previous
        version cloned the entire active slide during a size change. On some
        browsers that clone could remain above the gallery as a large duplicate
        image. The new version never uses that clone.
      */
      ${GALLERY_SELECTOR} .ag-size-change-freeze {
        display: none !important;
      }

      @media (prefers-reduced-motion: reduce) {
        ${GALLERY_SELECTOR}.ag-border-preview-ready
        [data-border-base-slide="true"] .ag-border-preview-surface,
        ${GALLERY_SELECTOR}.ag-border-preview-ready
        [data-border-base-slide="true"] .ag-border-preview-image {
          transition-duration: 1ms !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getLocaleLabels() {
    const language = (
      document.documentElement.getAttribute("lang") || ""
    ).toLowerCase();

    if (language.startsWith("sv")) {
      return {
        borderOn: "Vit marginal",
        borderOff: "Ingen marginal",
        borderOnDesc: function (size) {
          return `${size} vit kant runt motivet`;
        },
        borderOffDesc: "Motivet går ut i kanten"
      };
    }

    return {
      borderOn: "Border",
      borderOff: "No Border",
      borderOnDesc: function (size) {
        return `${size} border around the motif`;
      },
      borderOffDesc: "The motif goes all the way to the edge"
    };
  }

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.agSmoothBorderReady === "true") return;

    gallery.dataset.agSmoothBorderReady = "true";

    const scope = gallery.closest(".shopify-section") || document;
    let updateFrame = 0;
    let resizeFrame = 0;
    let settleFrame = 0;
    let settleToken = 0;
    let syncReleaseFrame = 0;
    let lastStateKey = "";
    let lastBorderInteractionAt = 0;
    let galleryObserver = null;
    let previewResizeObserver = null;
    let observedSurface = null;
    let observedContainer = null;
    let sizeTransitionOverlay = null;
    let sizeTransitionToken = 0;
    let sizeTransitionFrame = 0;
    let sizeTransitionRemoveTimer = 0;
    let lastSizeInteractionAt = 0;
    let galleryLockRequested = true;
    let borderGalleryResetFrame = 0;
    let borderGalleryResetTimer = 0;
    let cachedRealImageSet = null;
    const preloadedBorderSources = new Map();

    function preloadBorderSource(sourceData) {
      if (!sourceData || (!sourceData.src && !sourceData.srcset)) return;

      const sourceKey =
        sourceData.key ||
        [sourceData.src || "", sourceData.srcset || ""].join("|");

      if (preloadedBorderSources.has(sourceKey)) return;

      const preloadImage = new Image();
      preloadImage.decoding = "async";
      preloadImage.loading = "eager";

      try {
        preloadImage.fetchPriority = "high";
      } catch (error) {}

      if (sourceData.sizes) {
        preloadImage.sizes = sourceData.sizes;
      }

      if (sourceData.srcset) {
        preloadImage.srcset = sourceData.srcset;
      }

      if (sourceData.src) {
        preloadImage.src = sourceData.src;
      }

      /*
        Keep a strong reference so the browser can finish fetching/decoding it.
        This means the #noborder-hidden Border image is normally already cached
        before the customer clicks Border.
      */
      preloadedBorderSources.set(sourceKey, preloadImage);
    }

    /* Remove any duplicate left behind by an older cached script. */
    gallery.querySelectorAll(".ag-size-change-freeze").forEach(function (node) {
      node.remove();
    });
    gallery.classList.remove("ag-size-transition-active");

    function getLabelForInput(input, root) {
      if (!input) return null;

      const localRoot = root || scope;
      const wrappedLabel = input.closest("label");

      if (wrappedLabel) return wrappedLabel;
      if (!input.id) return null;

      const escapedId = window.CSS && typeof window.CSS.escape === "function"
        ? window.CSS.escape(input.id)
        : input.id.replace(/(["\\])/g, "\\$1");

      return (
        localRoot.querySelector(`label[for="${escapedId}"]`) ||
        scope.querySelector(`label[for="${escapedId}"]`)
      );
    }

    function getBorderFieldsets() {
      return Array.from(
        scope.querySelectorAll(
          '[data-border-picker], [data-option-role="border"]'
        )
      );
    }

    function getBorderInputs(fieldset) {
      if (!fieldset) return [];

      return Array.from(
        fieldset.querySelectorAll('input[type="radio"]')
      ).filter(function (input) {
        const value = normalize(input.value);

        return (
          BORDER_ON_VALUES.includes(value) ||
          BORDER_OFF_VALUES.includes(value)
        );
      });
    }

    function getSelectedSizeKey() {
      const checkedRadios = Array.from(
        scope.querySelectorAll('input[type="radio"]:checked')
      );

      for (const radio of checkedRadios) {
        const candidates = [
          radio.value,
          radio.getAttribute("aria-label"),
          radio.dataset.optionValue
        ];

        const label = getLabelForInput(radio, scope);
        if (label) candidates.push(label.textContent);

        for (const candidate of candidates) {
          const key = extractSizeKey(candidate);
          if (SIZE_TO_PADDING[key]) return key;
        }
      }

      const selects = Array.from(scope.querySelectorAll("select"));

      for (const select of selects) {
        const selectedOption = select.options[select.selectedIndex];
        const candidates = [
          select.value,
          selectedOption ? selectedOption.value : "",
          selectedOption ? selectedOption.textContent : ""
        ];

        for (const candidate of candidates) {
          const key = extractSizeKey(candidate);
          if (SIZE_TO_PADDING[key]) return key;
        }
      }

      return "";
    }

    function getSelectedPadding() {
      return SIZE_TO_PADDING[getSelectedSizeKey()] || 19;
    }

    function getSelectedMarginText() {
      return SIZE_TO_MARGIN[getSelectedSizeKey()] || "2 cm";
    }

    function getBorderValue() {
      const fieldsets = getBorderFieldsets();

      for (const fieldset of fieldsets) {
        const selectedInput = getBorderInputs(fieldset).find(function (input) {
          return input.checked;
        });

        if (selectedInput) return normalize(selectedInput.value);
      }

      const selects = Array.from(scope.querySelectorAll("select"));

      for (const select of selects) {
        const roleContainer = select.closest('[data-option-role="border"]');
        const role = normalize(
          roleContainer ? roleContainer.dataset.optionRole : ""
        );
        const value = normalize(select.value);
        const name = normalize(select.name);

        if (
          role === "border" ||
          name.includes("border") ||
          BORDER_ON_VALUES.includes(value) ||
          BORDER_OFF_VALUES.includes(value)
        ) {
          return value;
        }
      }

      return "";
    }

    function getNoBorderHiddenImages() {
      return Array.from(gallery.querySelectorAll("img")).filter(function (image) {
        if (!image) return false;

        const candidates = [
          image.getAttribute("alt"),
          image.alt,
          image.dataset ? image.dataset.mediaAlt : "",
          image.closest("[data-media-alt]")
            ? image.closest("[data-media-alt]").getAttribute("data-media-alt")
            : "",
          image.closest("[aria-label]")
            ? image.closest("[aria-label]").getAttribute("aria-label")
            : ""
        ];

        return candidates.some(hasNoBorderHiddenMarker);
      });
    }

    function getBestNoBorderHiddenImage() {
      const hiddenImages = getNoBorderHiddenImages();

      if (!hiddenImages.length) return null;

      return hiddenImages
        .map(function (image, index) {
          const inThumbnail = Boolean(
            image.closest(
              ".thumbnail, .thumbnail-carousel, .splide__thumbnail, [id*='Thumbnail'], [id*='thumbnail']"
            )
          );

          const inMainCarousel = Boolean(
            image.closest(
              ".main-carousel, [id^='Main-Carousel-']"
            )
          );

          let imageScore = scoreImage(image);

          /*
            Prefer the full-size hidden gallery media over a thumbnail carrying
            the same marker. This keeps the Border preview sharp.
          */
          if (inMainCarousel && !inThumbnail) {
            imageScore += 400000000;
          }

          if (!inThumbnail) {
            imageScore += 50000000;
          }

          imageScore -= index;

          return {
            image: image,
            score: imageScore
          };
        })
        .sort(function (first, second) {
          return second.score - first.score;
        })[0].image;
    }

    function elementContainsNoBorderHiddenMedia(element) {
      if (!element) return false;

      if (element.classList && element.classList.contains("ag-noborder-hidden-media")) {
        return true;
      }

      const images = element.matches && element.matches("img")
        ? [element]
        : Array.from(element.querySelectorAll ? element.querySelectorAll("img") : []);

      return images.some(function (image) {
        return hasNoBorderHiddenMarker(image.getAttribute("alt") || image.alt || "");
      });
    }

    function markNoBorderHiddenMedia() {
      const hiddenImages = getNoBorderHiddenImages();

      hiddenImages.forEach(function (image) {
        const nodes = [
          image.closest(".splide__slide"),
          image.closest(".thumbnail-list__item"),
          image.closest(".product__media-item"),
          image.closest(".product-media-container"),
          image.closest("[data-media-id]"),
          image.closest("li")
        ];

        nodes.forEach(function (node) {
          if (!node || node === gallery) return;
          node.classList.add("ag-noborder-hidden-media");
          node.setAttribute("data-ag-noborder-hidden-media", "true");
        });
      });

      return hiddenImages;
    }

    function getFirstNonHiddenMainImage() {
      const mainRoot =
        gallery.querySelector(".main-carousel") ||
        gallery.querySelector('[id^="Main-Carousel-"]') ||
        gallery;

      const images = Array.from(mainRoot.querySelectorAll("img")).filter(
        function (image) {
          if (
            image.classList.contains("ag-real-border-swap-image") ||
            image.closest(".thumbnail, .thumbnail-carousel, .splide__thumbnail")
          ) {
            return false;
          }

          return !elementContainsNoBorderHiddenMedia(
            image.closest(".splide__slide") || image
          );
        }
      );

      if (!images.length) return null;

      return images.slice().sort(function (first, second) {
        return scoreImage(second) - scoreImage(first);
      })[0];
    }

    function getFieldsetManualSource(fieldset, prefix, mode) {
      if (!fieldset) return null;

      const src = fieldset.dataset[prefix + "Src"] || "";
      const thumb = fieldset.dataset[prefix + "Thumb"] || "";
      const srcset = fieldset.dataset[prefix + "Srcset"] || "";

      return buildManualSource({
        mode: mode,
        src: src || thumb,
        srcset: srcset,
        width: fieldset.dataset[prefix + "Width"] || "",
        height: fieldset.dataset[prefix + "Height"] || "",
        alt: fieldset.dataset[prefix + "Alt"] || fieldset.dataset.borderThumbAlt || ""
      });
    }

    function getManualSwapSources() {
      const fieldset = getBorderFieldsets().find(function (item) {
        return item.dataset && (item.dataset.noborderSrc || item.dataset.noborderThumb);
      });

      if (!fieldset) return null;

      const noBorder = getFieldsetManualSource(fieldset, "noborder", "noborder-manual");
      const border = getFieldsetManualSource(fieldset, "border", "border-manual");

      if (!noBorder || !noBorder.src) return null;

      return {
        border: border,
        noBorder: noBorder,
        borderThumb: fieldset.dataset.borderThumb || (border && border.src) || "",
        noBorderThumb: fieldset.dataset.noborderThumb || noBorder.src || "",
        borderAlt: fieldset.dataset.borderAlt || fieldset.dataset.borderThumbAlt || "",
        noBorderAlt: fieldset.dataset.noborderAlt || fieldset.dataset.borderThumbAlt || ""
      };
    }

    function getNormalUploadedSourceFromGallery(preview, excludedSource) {
      const images = Array.from(gallery.querySelectorAll("img"));
      const candidates = [];

      images.forEach(function (image, index) {
        if (!image) return;
        if (image.classList && image.classList.contains("ag-real-border-swap-image")) return;

        const altCandidates = [
          image.getAttribute("alt"),
          image.alt,
          image.dataset ? image.dataset.mediaAlt : "",
          image.closest("[data-media-alt]")
            ? image.closest("[data-media-alt]").getAttribute("data-media-alt")
            : ""
        ];

        /*
          #noborder-hidden is the special BORDER preview in this store.
          Therefore it must never be selected as the normal/No Border image.
        */
        if (altCandidates.some(hasNoBorderHiddenMarker)) return;

        const parentSlide =
          image.closest(".splide__slide") ||
          image.closest("[data-media-id]") ||
          image;

        if (elementContainsNoBorderHiddenMedia(parentSlide)) return;

        const source = captureImageSource(image, "noborder-uploaded");
        if (!source || !source.src) return;

        if (
          excludedSource &&
          (
            sourceMatchesSource(source, excludedSource) ||
            imageMatchesSource(image, excludedSource)
          )
        ) {
          return;
        }

        const inThumbnail = Boolean(
          image.closest(
            ".thumbnail, .thumbnail-carousel, .splide__thumbnail, [id*='Thumbnail'], [id*='thumbnail']"
          )
        );

        const inMainCarousel = Boolean(
          image.closest(".main-carousel, [id^='Main-Carousel-']")
        );

        let candidateScore = scoreImage(image);

        if (inMainCarousel && !inThumbnail) candidateScore += 400000000;
        if (!inThumbnail) candidateScore += 50000000;
        if (preview && image === preview.image) candidateScore += 25000000;
        if (inThumbnail) candidateScore += 1000000;
        candidateScore -= index;

        candidates.push({
          source: source,
          score: candidateScore
        });
      });

      candidates.sort(function (first, second) {
        return second.score - first.score;
      });

      return candidates.length ? candidates[0].source : null;
    }

    function getRealImageSet(preview) {
      markNoBorderHiddenMedia();

      const manualSources = getManualSwapSources();

      /*
        IMPORTANT FOR THIS STORE:
        The uploaded image carrying #noborder-hidden is the dedicated BORDER
        image. The normal first/main artwork image is the NO BORDER image.

        The previous code treated #noborder-hidden as No Border, which is why
        selecting Border could keep showing the normal image.
      */
      let borderSource = manualSources ? manualSources.border : null;

      if (!borderSource || !borderSource.src) {
        const bestHiddenImage =
          getBestNoBorderHiddenImage();

        borderSource = captureImageSource(
          bestHiddenImage,
          "border-noborder-hidden-marker"
        );
      }

      if (!borderSource || !borderSource.src) {
        cachedRealImageSet = null;
        return null;
      }

      /*
        Preserve the normal visible first image as the No Border source.
        Never overwrite this image. The Border image is rendered as a cached
        visual layer above it, so returning to No Border is instant.
      */
      if (
        preview &&
        preview.image &&
        !hasNoBorderHiddenMarker(
          preview.image.getAttribute("alt") || preview.image.alt || ""
        ) &&
        !imageMatchesSource(preview.image, borderSource)
      ) {
        const currentPreviewSource = captureImageSource(
          preview.image,
          "noborder-original"
        );

        if (currentPreviewSource && currentPreviewSource.src) {
          preview.image.__agNoBorderOriginalSource =
            currentPreviewSource;
        }
      }

      let noBorderSource =
        manualSources && manualSources.noBorder
          ? manualSources.noBorder
          : null;

      if (
        (!noBorderSource || !noBorderSource.src) &&
        preview &&
        preview.image &&
        preview.image.__agNoBorderOriginalSource &&
        !sourceMatchesSource(
          preview.image.__agNoBorderOriginalSource,
          borderSource
        )
      ) {
        noBorderSource =
          preview.image.__agNoBorderOriginalSource;
      }

      if (!noBorderSource || !noBorderSource.src) {
        noBorderSource = getNormalUploadedSourceFromGallery(
          preview,
          borderSource
        );
      }

      if (
        (!noBorderSource || !noBorderSource.src) &&
        cachedRealImageSet &&
        cachedRealImageSet.border &&
        cachedRealImageSet.noBorder &&
        sourceMatchesSource(
          cachedRealImageSet.border,
          borderSource
        )
      ) {
        noBorderSource = cachedRealImageSet.noBorder;
      }

      if (!noBorderSource || !noBorderSource.src) {
        const normalImage = getFirstNonHiddenMainImage();

        if (
          normalImage &&
          !imageMatchesSource(normalImage, borderSource)
        ) {
          noBorderSource = captureImageSource(
            normalImage,
            "noborder-uploaded"
          );
        }
      }

      if (!noBorderSource || !noBorderSource.src) {
        cachedRealImageSet = null;
        return null;
      }

      cachedRealImageSet = {
        border: borderSource,
        noBorder: noBorderSource,

        borderThumb:
          (manualSources && manualSources.borderThumb) ||
          borderSource.src ||
          "",

        noBorderThumb:
          (manualSources && manualSources.noBorderThumb) ||
          noBorderSource.src ||
          "",

        borderAlt:
          (manualSources && manualSources.borderAlt) ||
          borderSource.alt ||
          "Border",

        noBorderAlt:
          (manualSources && manualSources.noBorderAlt) ||
          noBorderSource.alt ||
          "No Border"
      };

      /*
        Start loading the #noborder-hidden Border image immediately.
        The first Border click therefore does not have to wait for a network
        request in the normal case.
      */
      preloadBorderSource(borderSource);

      return cachedRealImageSet;
    }

    function getBorderCardThumbnail(fieldset, isBorderOn) {
      const realImageSet = getRealImageSet(
        getPreviewElements()
      );

      if (fieldset) {
        if (realImageSet) {
          fieldset.dataset.agRealBorderImageMode = "true";
        } else {
          delete fieldset.dataset.agRealBorderImageMode;
        }
      }

      if (realImageSet) {
        return {
          src: isBorderOn
            ? realImageSet.borderThumb
            : realImageSet.noBorderThumb,

          alt: isBorderOn
            ? realImageSet.borderAlt
            : realImageSet.noBorderAlt
        };
      }

      /*
        Safety fallback:
        Even before the complete uploaded pair has been resolved, use the
        #noborder-hidden image for the Border option card when it exists.
      */
      const hiddenBorderImage =
        getBestNoBorderHiddenImage();

      const hiddenBorderSource =
        hiddenBorderImage
          ? getBestImageUrl(hiddenBorderImage)
          : "";

      const swapData = gallery.querySelector(
        '[id^="BorderSwapData-"]'
      );

      const manualNoBorderSource = swapData
        ? (
            swapData.dataset.noborderSrc ||
            ""
          )
        : "";

      const mainImage =
        gallery.querySelector(
          '[data-border-base-slide="true"] img'
        ) ||
        getFirstNonHiddenMainImage();

      const normalSource =
        (mainImage &&
          (
            mainImage.currentSrc ||
            mainImage.src
          )) ||
        manualNoBorderSource ||
        (fieldset &&
          fieldset.dataset.borderThumb) ||
        "";

      return {
        src: isBorderOn
          ? (hiddenBorderSource || normalSource)
          : normalSource,

        alt: fieldset
          ? fieldset.dataset.borderThumbAlt || ""
          : ""
      };
    }

    function buildCardHtml(options) {
      const thumbClass = options.withBorder
        ? "is-with-border"
        : "is-without-border";

      const imageHtml = options.thumbSrc
        ? `<img src="${escapeHtml(options.thumbSrc)}" alt="${escapeHtml(
            options.thumbAlt || options.title
          )}">`
        : "";

      return `
        <span class="ag-border-card__thumb ${thumbClass}">
          ${imageHtml}
        </span>
        <span class="ag-border-card__text">
          <span class="ag-border-card__title">${escapeHtml(
            options.title
          )}</span>
          <span class="ag-border-card__desc">${escapeHtml(
            options.description
          )}</span>
        </span>
        <span class="ag-border-card__indicator" aria-hidden="true">
          <svg viewBox="0 0 20 20" fill="none">
            <path d="M5 10.5L8.2 13.7L15 6.9"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg>
        </span>
      `;
    }

    function updateBorderCardFieldset(fieldset) {
      const labels = getLocaleLabels();
      const marginText = getSelectedMarginText();
      const inputs = getBorderInputs(fieldset);

      inputs.forEach(function (input) {
        const value = normalize(input.value);
        const label = getLabelForInput(input, fieldset);

        if (!label) return;

        const isBorderOn = BORDER_ON_VALUES.includes(value);
        const isBorderOff = BORDER_OFF_VALUES.includes(value);

        if (!isBorderOn && !isBorderOff) return;

        const title = isBorderOn ? labels.borderOn : labels.borderOff;
        const description = isBorderOn
          ? labels.borderOnDesc(marginText)
          : labels.borderOffDesc;

        label.classList.add("ag-border-card");
        label.classList.toggle("is-selected", input.checked);

        let content = Array.from(label.children).find(function (child) {
          return child.classList &&
            child.classList.contains("ag-border-card__content");
        });

        if (!content) {
          content = document.createElement("span");
          content.className = "ag-border-card__content";

          if (input.parentElement === label) {
            input.insertAdjacentElement("afterend", content);
          } else {
            label.appendChild(content);
          }
        }

        const thumb = getBorderCardThumbnail(fieldset, isBorderOn);
        const signature = [
          thumb.src,
          thumb.alt,
          title,
          description,
          isBorderOn ? "1" : "0"
        ].join("|");

        if (content.dataset.agSignature !== signature) {
          content.innerHTML = buildCardHtml({
            thumbSrc: thumb.src,
            thumbAlt: thumb.alt,
            title: title,
            description: description,
            withBorder: isBorderOn
          });
          content.dataset.agSignature = signature;
        }
      });

      const selectedInput = inputs.find(function (input) {
        return input.checked;
      });
      const selectedText = fieldset.querySelector(".form__label-value");

      if (selectedInput && selectedText) {
        const selectedValue = normalize(selectedInput.value);
        selectedText.textContent = BORDER_ON_VALUES.includes(selectedValue)
          ? labels.borderOn
          : labels.borderOff;
      }
    }

    function updateBorderSelectText() {
      const labels = getLocaleLabels();

      scope.querySelectorAll("select").forEach(function (select) {
        Array.from(select.options).forEach(function (option) {
          const value = normalize(option.value);

          if (BORDER_ON_VALUES.includes(value)) {
            option.textContent = labels.borderOn;
          } else if (BORDER_OFF_VALUES.includes(value)) {
            option.textContent = labels.borderOff;
          }
        });
      });
    }

    function updateOptionUi() {
      getBorderFieldsets().forEach(updateBorderCardFieldset);
      updateBorderSelectText();
    }

    function getPreviewElements() {
      markNoBorderHiddenMedia();

      const assignedBaseSlide = gallery.querySelector('[data-border-base-slide="true"]');
      const slideCandidates = Array.from(
        gallery.querySelectorAll(
          '.main-carousel .splide__slide:not(.splide__slide--clone), .splide__slide:not(.splide__slide--clone)'
        )
      );

      let baseSlide = null;

      if (
        assignedBaseSlide &&
        !elementContainsNoBorderHiddenMedia(assignedBaseSlide)
      ) {
        baseSlide = assignedBaseSlide;
      }

      if (!baseSlide) {
        baseSlide = slideCandidates.find(function (slide) {
          return !elementContainsNoBorderHiddenMedia(slide);
        }) || slideCandidates[0] || null;
      }

      if (!baseSlide) return null;

      const images = Array.from(baseSlide.querySelectorAll("img")).filter(
        function (image) {
          if (image.classList.contains("ag-real-border-swap-image")) {
            return false;
          }

          return !image.closest(
            ".thumbnail, .thumbnail-carousel, .splide__thumbnail"
          );
        }
      );

      if (!images.length) return null;

      const image = images.slice().sort(function (first, second) {
        const firstArea =
          (first.clientWidth || first.naturalWidth || 0) *
          (first.clientHeight || first.naturalHeight || 0);
        const secondArea =
          (second.clientWidth || second.naturalWidth || 0) *
          (second.clientHeight || second.naturalHeight || 0);

        return secondArea - firstArea;
      })[0];

      const surface =
        image.closest(".media") ||
        image.closest(".product__media") ||
        image.closest(".global-media-settings") ||
        image.closest(".product-media-container") ||
        image.parentElement;

      const mediaContainer =
        image.closest(".product-media-container") || surface;

      return {
        baseSlide: baseSlide,
        image: image,
        surface: surface,
        mediaContainer: mediaContainer
      };
    }

    function clearRealSwapImage(preview) {
      const root = preview && preview.surface ? preview.surface : gallery;

      if (preview && preview.image) {
        preview.image.classList.remove("ag-border-original-hidden");
      }

      if (root) {
        root.querySelectorAll(".ag-real-border-swap-image").forEach(function (image) {
          image.remove();
        });

        if (preview && preview.surface) {
          preview.surface.classList.remove("ag-has-real-border-swap-image");
        }
      }
    }

    function applyRealSwapImage(preview, sourceData) {
      if (
        !preview ||
        !preview.surface ||
        !preview.image ||
        !sourceData ||
        (!sourceData.src && !sourceData.srcset)
      ) {
        return false;
      }

      const sourceKey =
        sourceData.key ||
        [sourceData.src || "", sourceData.srcset || ""].join("|");

      const originalNoBorderSource =
        preview.image.__agNoBorderOriginalSource || null;

      const selectedIsOriginalNoBorder = Boolean(
        (
          originalNoBorderSource &&
          sourceMatchesSource(
            originalNoBorderSource,
            sourceData
          )
        ) ||
        imageMatchesSource(preview.image, sourceData)
      );

      const allSwapImages = Array.from(
        preview.surface.querySelectorAll(
          ".ag-real-border-swap-image"
        )
      );

      /*
        NO BORDER:
        The normal gallery image already is the No Border image, so do not
        create or load another image. Just reveal the original immediately.
      */
      if (selectedIsOriginalNoBorder) {
        allSwapImages.forEach(function (image) {
          image.classList.remove("is-active");
        });

        preview.image.classList.remove(
          "ag-border-original-hidden"
        );

        preview.surface.classList.remove(
          "ag-has-real-border-swap-image"
        );

        return true;
      }

      /*
        BORDER:
        Use the #noborder-hidden source as a persistent cached layer. Unlike the
        old code, the layer is NOT deleted when No Border is selected, so the
        next Border click is only an opacity/visibility toggle.
      */
      let swapImage = allSwapImages.find(function (image) {
        return (
          image.dataset.agRealBorderSourceKey === sourceKey
        );
      });

      if (!swapImage) {
        swapImage = document.createElement("img");
        swapImage.className =
          "ag-real-border-swap-image is-loading is-active";
        swapImage.dataset.agRealBorderSourceKey = sourceKey;
        swapImage.setAttribute("alt", "");
        swapImage.setAttribute("aria-hidden", "true");
        swapImage.setAttribute("draggable", "false");
        swapImage.decoding = "async";
        swapImage.loading = "eager";

        applyImageSource(swapImage, sourceData);
        preview.surface.appendChild(swapImage);

        function revealLoadedSwap() {
          if (!swapImage.isConnected) return;

          swapImage.classList.remove("is-loading");

          if (swapImage.classList.contains("is-active")) {
            preview.image.classList.add(
              "ag-border-original-hidden"
            );

            preview.surface.classList.add(
              "ag-has-real-border-swap-image"
            );
          }
        }

        function removeFailedSwap() {
          if (!swapImage.isConnected) return;

          swapImage.remove();

          preview.image.classList.remove(
            "ag-border-original-hidden"
          );

          preview.surface.classList.remove(
            "ag-has-real-border-swap-image"
          );
        }

        if (
          swapImage.complete &&
          swapImage.naturalWidth > 0
        ) {
          requestAnimationFrame(revealLoadedSwap);
        } else {
          swapImage.addEventListener(
            "load",
            revealLoadedSwap,
            { once: true }
          );

          swapImage.addEventListener(
            "error",
            removeFailedSwap,
            { once: true }
          );
        }
      }

      /*
        Keep all cached swap layers in the DOM but activate only the requested
        one. This prevents repeated downloads/re-decoding.
      */
      Array.from(
        preview.surface.querySelectorAll(
          ".ag-real-border-swap-image"
        )
      ).forEach(function (image) {
        image.classList.toggle(
          "is-active",
          image === swapImage
        );
      });

      if (
        !swapImage.classList.contains("is-loading") &&
        swapImage.complete &&
        swapImage.naturalWidth > 0
      ) {
        preview.image.classList.add(
          "ag-border-original-hidden"
        );

        preview.surface.classList.add(
          "ag-has-real-border-swap-image"
        );
      }

      return true;
    }

    function getMainCarouselElement() {
      return (
        gallery.querySelector('[id^="Main-Carousel-"]') ||
        gallery.querySelector(".main-carousel") ||
        null
      );
    }

    function getThumbnailCarouselElement() {
      return (
        gallery.querySelector('[id^="Thumbnail-Carousel-"]') ||
        gallery.querySelector(".thumbnail-carousel") ||
        null
      );
    }

    function getRealSlides(carousel) {
      if (!carousel) return [];

      return Array.from(
        carousel.querySelectorAll(".splide__slide:not(.splide__slide--clone)")
      );
    }

    function getFirstVisibleUploadedBorderSlideIndex(carousel) {
      const slides = getRealSlides(carousel);
      if (!slides.length) return 0;

      const index = slides.findIndex(function (slide) {
        return !elementContainsNoBorderHiddenMedia(slide);
      });

      return index >= 0 ? index : 0;
    }

    function forceSlideClasses(carousel, targetIndex) {
      const slides = getRealSlides(carousel);
      if (!slides.length) return;

      slides.forEach(function (slide, index) {
        const active = index === targetIndex;
        slide.classList.toggle("is-active", active);
        slide.classList.toggle("is-visible", active);
        slide.classList.toggle("is-selected", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
        if (active) {
          slide.setAttribute("data-selected", "true");
        } else {
          slide.removeAttribute("data-selected");
        }
      });
    }

    function goCarouselToSlide(carousel, index) {
      if (!carousel) return false;

      const splide = carousel.splide;
      if (splide && typeof splide.go === "function") {
        if (typeof splide.index !== "number" || splide.index !== index) {
          splide.go(index);
        }
        return true;
      }

      forceSlideClasses(carousel, index);
      return false;
    }

    function clickVisibleThumbnailAtIndex(carousel, index) {
      const slides = getRealSlides(carousel);
      const slide = slides[index];
      if (!slide || elementContainsNoBorderHiddenMedia(slide)) return;

      const clickTarget =
        slide.querySelector("button, [role='button'], a, .thumbnail") || slide;

      if (clickTarget && typeof clickTarget.click === "function") {
        clickTarget.click();
      }
    }

    function requestGalleryLockOnPosterSlide() {
      galleryLockRequested = true;
    }

    function returnGalleryToMainThumbnail() {
      /*
        Border / No Border must always return to the first/main product image,
        even when the customer is currently viewing image 2, 3, etc.

        Run the reset immediately and once again after Shopify/Splide has had
        a chance to refresh the gallery for the newly selected option.
      */
      requestGalleryLockOnPosterSlide();
      lockGalleryOnUploadedBorderSlide();

      cancelAnimationFrame(borderGalleryResetFrame);
      clearTimeout(borderGalleryResetTimer);

      borderGalleryResetFrame = requestAnimationFrame(function () {
        lockGalleryOnUploadedBorderSlide();

        borderGalleryResetFrame = requestAnimationFrame(function () {
          lockGalleryOnUploadedBorderSlide();
        });
      });

      borderGalleryResetTimer = window.setTimeout(function () {
        lockGalleryOnUploadedBorderSlide();
        galleryLockRequested = false;
      }, 180);
    }

    function lockGalleryOnUploadedBorderSlide() {
      markNoBorderHiddenMedia();

      const mainCarousel = getMainCarouselElement();
      const thumbCarousel = getThumbnailCarouselElement();
      const targetIndex = getFirstVisibleUploadedBorderSlideIndex(mainCarousel);

      if (mainCarousel) {
        goCarouselToSlide(mainCarousel, targetIndex);
      }

      if (thumbCarousel) {
        goCarouselToSlide(thumbCarousel, targetIndex);
        clickVisibleThumbnailAtIndex(thumbCarousel, targetIndex);
      }
    }

    function consumeGalleryLockRequest() {
      if (!galleryLockRequested) return false;
      galleryLockRequested = false;
      lockGalleryOnUploadedBorderSlide();
      return true;
    }

    function removeSizeTransitionOverlay() {
      sizeTransitionToken += 1;
      cancelAnimationFrame(sizeTransitionFrame);
      clearTimeout(sizeTransitionRemoveTimer);

      if (sizeTransitionOverlay && sizeTransitionOverlay.parentNode) {
        sizeTransitionOverlay.parentNode.removeChild(sizeTransitionOverlay);
      }

      sizeTransitionOverlay = null;

      gallery.querySelectorAll(".ag-size-change-freeze").forEach(function (node) {
        node.remove();
      });

      gallery.classList.remove("ag-size-transition-active");
    }

    function beginSizeTransition() {
      /*
        Do not clone the current slide. The old clone was the large floating
        duplicate visible in the screenshot. Keep the real gallery image in
        place and let its height/padding transition to the new size.
      */
      removeSizeTransitionOverlay();
      lastSizeInteractionAt = performance.now();
    }

    function scheduleSizeTransitionRelease() {
      /*
        Re-attach the preview classes for a few animation frames because some
        Shopify themes replace the image node after the option change. No copy
        of the image is created, so there is nothing that can float above the
        gallery or remain stuck on screen.
      */
      removeSizeTransitionOverlay();

      sizeTransitionToken += 1;
      const currentToken = sizeTransitionToken;
      let frameCount = 0;

      function step() {
        if (currentToken !== sizeTransitionToken) return;

        lastStateKey = "";
        applyPreview(true);
        enableTransitionsAfterInitialPaint();

        frameCount += 1;

        if (frameCount < 10) {
          sizeTransitionFrame = requestAnimationFrame(step);
        }
      }

      sizeTransitionFrame = requestAnimationFrame(step);
    }

    function getArtworkRatio(preview, sourceData) {
      /*
        Use one permanent outer-poster ratio for both Border and No Border.
        Previously the function preferred the currently selected source. When
        the bordered and non-bordered uploads had slightly different pixel
        ratios, the surface height was recalculated and the whole poster looked
        a little smaller or larger after selecting Border.
      */
      const storedRatio = parseFloat(
        preview.surface.dataset.agArtworkRatio || ""
      );

      if (Number.isFinite(storedRatio) && storedRatio > 0) {
        return storedRatio;
      }

      let ratio = 0;

      const swapData = gallery.querySelector('[id^="BorderSwapData-"]');

      if (swapData) {
        const sourceWidth = parseFloat(
          swapData.dataset.noborderWidth || ""
        );
        const sourceHeight = parseFloat(
          swapData.dataset.noborderHeight || ""
        );

        if (
          Number.isFinite(sourceWidth) &&
          Number.isFinite(sourceHeight) &&
          sourceWidth > 0 &&
          sourceHeight > 0
        ) {
          ratio = sourceWidth / sourceHeight;
        }
      }

      /*
        In real uploaded-image mode, use the normal No Border artwork ratio as
        the permanent outer poster ratio. The #noborder-hidden Border upload is
        contained inside exactly the same box.
      */
      if (
        (!Number.isFinite(ratio) || ratio <= 0) &&
        cachedRealImageSet &&
        cachedRealImageSet.noBorder &&
        Number.isFinite(cachedRealImageSet.noBorder.width) &&
        Number.isFinite(cachedRealImageSet.noBorder.height) &&
        cachedRealImageSet.noBorder.width > 0 &&
        cachedRealImageSet.noBorder.height > 0
      ) {
        ratio =
          cachedRealImageSet.noBorder.width /
          cachedRealImageSet.noBorder.height;
      }

      if (
        (!Number.isFinite(ratio) || ratio <= 0) &&
        preview.image.naturalWidth &&
        preview.image.naturalHeight
      ) {
        ratio =
          preview.image.naturalWidth /
          preview.image.naturalHeight;
      }

      if (
        (!Number.isFinite(ratio) || ratio <= 0) &&
        sourceData &&
        Number.isFinite(sourceData.width) &&
        Number.isFinite(sourceData.height) &&
        sourceData.width > 0 &&
        sourceData.height > 0
      ) {
        ratio = sourceData.width / sourceData.height;
      }

      if (!Number.isFinite(ratio) || ratio <= 0) {
        const rectangle = preview.surface.getBoundingClientRect();

        ratio =
          rectangle.width && rectangle.height
            ? rectangle.width / rectangle.height
            : 0;
      }

      if (!Number.isFinite(ratio) || ratio <= 0) {
        ratio = 0.75;
      }

      preview.surface.dataset.agArtworkRatio = String(ratio);
      return ratio;
    }

    function removeStalePreviewClasses(currentPreview) {
      gallery.querySelectorAll(".ag-real-border-swap-image").forEach(
        function (image) {
          if (!currentPreview.surface || !currentPreview.surface.contains(image)) {
            image.remove();
          }
        }
      );

      gallery.querySelectorAll(".ag-border-preview-image").forEach(
        function (image) {
          if (image !== currentPreview.image) {
            image.classList.remove("ag-border-preview-image", "ag-border-original-hidden");
          }
        }
      );

      gallery.querySelectorAll(".ag-border-preview-surface").forEach(
        function (surface) {
          if (surface !== currentPreview.surface) {
            surface.classList.remove(
              "ag-border-preview-surface",
              "ag-border-preview-geometry"
            );
            surface.style.removeProperty(
              "--ag-border-preview-surface-height"
            );
          }
        }
      );

      gallery.querySelectorAll(".ag-border-preview-active").forEach(
        function (slide) {
          if (slide !== currentPreview.baseSlide) {
            slide.classList.remove("ag-border-preview-active");
          }
        }
      );
    }

    function toPixels(value) {
      const parsed = parseFloat(value || "0");
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function getSurfaceMetrics(preview) {
      const rectangle = preview.surface.getBoundingClientRect();
      const styles = window.getComputedStyle(preview.surface);

      const borderLeft = toPixels(styles.borderLeftWidth);
      const borderRight = toPixels(styles.borderRightWidth);
      const borderTop = toPixels(styles.borderTopWidth);
      const borderBottom = toPixels(styles.borderBottomWidth);
      const paddingLeft = toPixels(styles.paddingLeft);
      const paddingRight = toPixels(styles.paddingRight);
      const paddingTop = toPixels(styles.paddingTop);
      const paddingBottom = toPixels(styles.paddingBottom);

      const horizontalExtras =
        borderLeft + borderRight + paddingLeft + paddingRight;
      const verticalExtras =
        borderTop + borderBottom + paddingTop + paddingBottom;

      const contentWidth = Math.max(
        1,
        rectangle.width - horizontalExtras
      );

      return {
        outerWidth: rectangle.width,
        contentWidth: contentWidth,
        horizontalExtras: horizontalExtras,
        verticalExtras: verticalExtras,
        signature: [
          Math.round(rectangle.width * 100) / 100,
          Math.round(contentWidth * 100) / 100,
          Math.round(horizontalExtras * 100) / 100,
          Math.round(verticalExtras * 100) / 100
        ].join(":")
      };
    }

    function updateGeometry(preview, borderEnabled, padding, sourceData) {
      const metrics = getSurfaceMetrics(preview);
      if (!metrics.outerWidth) return metrics;

      /*
        Keep the outside dimensions identical in every state.

        Uploaded-image mode uses the No Border source ratio as the permanent
        outer ratio. Fallback code-padding mode uses the original full artwork
        ratio. Padding remains inside that same permanent outer poster box.
      */
      const artworkRatio = getArtworkRatio(preview, sourceData);
      const contentHeight =
        metrics.contentWidth / artworkRatio;
      const targetOuterHeight =
        contentHeight + metrics.verticalExtras;

      preview.surface.style.setProperty(
        "--ag-border-preview-surface-height",
        `${targetOuterHeight}px`
      );
      preview.surface.classList.add("ag-border-preview-geometry");

      return metrics;
    }

    function applyPreview(force) {
      const preview = getPreviewElements();
      if (!preview) return;

      const padding = getSelectedPadding();
      const borderValue = getBorderValue();
      const borderEnabled = BORDER_ON_VALUES.includes(borderValue);
      const realImageSet = getRealImageSet(preview);

      /*
        Automatic two-mode behaviour:

        1. REAL UPLOADED PAIR
           - Border: uploaded image marked #noborder-hidden.
           - No Border: normal first/main uploaded artwork image.
           - The Border source is preloaded and kept cached in the DOM.
           - No CSS padding is applied.

        2. CODE-PADDING FALLBACK
           - Used when a complete uploaded pair cannot be found.
           - The original full/no-padding artwork remains the source.
           - Border adds equal CSS padding inside the same outer dimensions.
      */
      const useUploadedImagePair = Boolean(
        realImageSet &&
        realImageSet.border &&
        realImageSet.border.src &&
        realImageSet.noBorder &&
        realImageSet.noBorder.src
      );

      const sourceData = useUploadedImagePair
        ? (borderEnabled
            ? realImageSet.border
            : realImageSet.noBorder)
        : null;

      const effectivePadding =
        !useUploadedImagePair && borderEnabled
          ? padding
          : 0;

      let geometrySource = null;

      if (useUploadedImagePair) {
        geometrySource = realImageSet.noBorder;
      } else if (
        preview.image.__agNoBorderOriginalSource &&
        preview.image.__agNoBorderOriginalSource.src
      ) {
        geometrySource = preview.image.__agNoBorderOriginalSource;
      } else {
        geometrySource = captureImageSource(
          preview.image,
          "code-padding-original"
        );
      }

      const metrics = getSurfaceMetrics(preview);
      const sourceKey = useUploadedImagePair
        ? (sourceData.key || sourceData.src || "")
        : (
            geometrySource &&
            (geometrySource.key || geometrySource.src)
          ) ||
          preview.image.currentSrc ||
          preview.image.src ||
          "";

      const stateKey = [
        useUploadedImagePair
          ? (borderEnabled
              ? "uploaded-border"
              : "uploaded-no-border")
          : (borderEnabled
              ? "code-padding-border"
              : "code-padding-no-border"),
        effectivePadding,
        getArtworkRatio(preview, geometrySource),
        metrics.signature,
        sourceKey
      ].join("|");

      if (!force && stateKey === lastStateKey) return preview;
      lastStateKey = stateKey;

      removeStalePreviewClasses(preview);

      preview.baseSlide.style.setProperty(
        "--ag-border-preview-padding",
        `${effectivePadding}px`
      );

      preview.image.classList.add("ag-border-preview-image");
      preview.surface.classList.add("ag-border-preview-surface");

      if (useUploadedImagePair) {
        /* Real-image mode: Border uses #noborder-hidden; No Border uses original. */
        consumeGalleryLockRequest();
        gallery.classList.add("ag-real-border-image-mode");
        preview.mediaContainer.classList.remove("use-code-padding");
        applyRealSwapImage(preview, sourceData);
      } else {
        /* Fallback mode: keep the original image and create Border via CSS. */
        gallery.classList.remove("ag-real-border-image-mode");
        clearRealSwapImage(preview);
        preview.mediaContainer.classList.add("use-code-padding");
      }

      updateGeometry(
        preview,
        borderEnabled,
        effectivePadding,
        geometrySource
      );

      connectPreviewResizeObserver(preview);

      preview.baseSlide.classList.toggle(
        "ag-border-preview-active",
        borderEnabled
      );

      preview.mediaContainer.classList.toggle(
        "border-active",
        borderEnabled
      );

      preview.mediaContainer.classList.toggle(
        "no-border-active",
        !borderEnabled
      );

      if (preview.image.complete) {
        requestAnimationFrame(function () {
          updateGeometry(
            preview,
            borderEnabled,
            effectivePadding,
            geometrySource
          );
        });
      } else {
        preview.image.addEventListener(
          "load",
          function () {
            lastStateKey = "";
            applyPreview(true);
          },
          { once: true }
        );
      }

      return preview;
    }

    function connectPreviewResizeObserver(preview) {
      if (typeof ResizeObserver !== "function") return;

      if (!previewResizeObserver) {
        previewResizeObserver = new ResizeObserver(function () {
          const recentBorderInteraction =
            performance.now() - lastBorderInteractionAt < 850;
          const recentSizeInteraction =
            performance.now() - lastSizeInteractionAt < 1400;

          if (sizeTransitionOverlay || recentSizeInteraction) {
            runUpdate(true);
            scheduleSizeTransitionRelease();
          } else if (recentBorderInteraction) {
            runUpdate(true);
          } else {
            settleLayout();
          }
        });
      }

      if (observedSurface !== preview.surface) {
        if (observedSurface) {
          previewResizeObserver.unobserve(observedSurface);
        }
        observedSurface = preview.surface;
        previewResizeObserver.observe(observedSurface);
      }

      if (
        preview.mediaContainer &&
        preview.mediaContainer !== preview.surface &&
        observedContainer !== preview.mediaContainer
      ) {
        if (observedContainer) {
          previewResizeObserver.unobserve(observedContainer);
        }
        observedContainer = preview.mediaContainer;
        previewResizeObserver.observe(observedContainer);
      }
    }

    function enableTransitionsAfterInitialPaint() {
      if (gallery.classList.contains("ag-border-preview-ready")) return;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          gallery.classList.add("ag-border-preview-ready");
        });
      });
    }

    function releaseLayoutSync() {
      cancelAnimationFrame(syncReleaseFrame);
      syncReleaseFrame = requestAnimationFrame(function () {
        syncReleaseFrame = requestAnimationFrame(function () {
          gallery.classList.remove("ag-border-layout-syncing");
        });
      });
    }

    function runUpdate(force) {
      cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(function () {
        updateOptionUi();
        applyPreview(Boolean(force));
        enableTransitionsAfterInitialPaint();
      });
    }

    function settleLayout() {
      settleToken += 1;
      const currentToken = settleToken;
      let frames = 0;
      let stableFrames = 0;
      let previousSignature = "";

      cancelAnimationFrame(settleFrame);
      gallery.classList.add("ag-border-layout-syncing");
      lastStateKey = "";
      updateOptionUi();

      function step() {
        if (currentToken !== settleToken) return;

        const preview = applyPreview(true);
        enableTransitionsAfterInitialPaint();

        if (!preview) {
          releaseLayoutSync();
          return;
        }

        const metrics = getSurfaceMetrics(preview);
        const currentBorderValue = getBorderValue();
        const currentBorderEnabled = BORDER_ON_VALUES.includes(currentBorderValue);
        const currentSourceData = cachedRealImageSet
          ? (currentBorderEnabled ? cachedRealImageSet.border : cachedRealImageSet.noBorder)
          : null;
        const signature = [
          metrics.signature,
          getArtworkRatio(preview, currentSourceData),
          currentBorderValue,
          cachedRealImageSet ? "real-uploaded-images" : "single-uploaded-image",
          "no-code-padding"
        ].join("|");

        if (signature === previousSignature) {
          stableFrames += 1;
        } else {
          stableFrames = 0;
          previousSignature = signature;
        }

        frames += 1;

        if (frames < 10 && stableFrames < 2) {
          settleFrame = requestAnimationFrame(step);
        } else {
          releaseLayoutSync();
        }
      }

      settleFrame = requestAnimationFrame(step);
    }

    function isBorderControl(control) {
      if (!(control instanceof Element)) return false;

      const fieldset = control.closest(
        '[data-border-picker], [data-option-role="border"]'
      );

      if (fieldset && control.matches('input[type="radio"]')) {
        return getBorderInputs(fieldset).includes(control);
      }

      if (control.matches("select")) {
        const value = normalize(control.value);
        const name = normalize(control.name);
        const roleContainer = control.closest('[data-option-role="border"]');
        const role = normalize(
          roleContainer ? roleContainer.dataset.optionRole : ""
        );

        return (
          role === "border" ||
          name.includes("border") ||
          BORDER_ON_VALUES.includes(value) ||
          BORDER_OFF_VALUES.includes(value)
        );
      }

      return false;
    }

    function isSizeControl(control) {
      if (!(control instanceof Element)) return false;

      if (control.matches('input[type="radio"]')) {
        const candidates = [
          control.value,
          control.getAttribute("aria-label"),
          control.dataset.optionValue
        ];
        const label = getLabelForInput(control, scope);
        if (label) candidates.push(label.textContent);

        return candidates.some(function (candidate) {
          return Boolean(SIZE_TO_PADDING[extractSizeKey(candidate)]);
        });
      }

      if (control.matches("select")) {
        const option = control.options[control.selectedIndex];
        const candidates = [
          control.value,
          option ? option.value : "",
          option ? option.textContent : ""
        ];

        return candidates.some(function (candidate) {
          return Boolean(SIZE_TO_PADDING[extractSizeKey(candidate)]);
        });
      }

      return false;
    }

    function isFrameControl(control) {
      if (!(control instanceof Element)) return false;

      if (control.matches('input[type="radio"], select')) {
        const roleContainer = control.closest('[data-option-role="frame"], [data-frame-picker]');
        return Boolean(roleContainer);
      }

      return false;
    }

    function resolveControlFromTarget(target) {
      if (!(target instanceof Element)) return null;

      if (target.matches('input[type="radio"], select')) return target;

      const label = target.closest("label");
      if (!label || !scope.contains(label)) return null;

      if (label.control) return label.control;

      const nestedInput = label.querySelector('input[type="radio"]');
      if (nestedInput) return nestedInput;

      const inputId = label.getAttribute("for");
      if (!inputId) return null;

      return scope.querySelector(
        `[id="${inputId.replace(/(["\\])/g, "\\$1")}"]`
      );
    }

    function prepareSizeTransitionFromTarget(target) {
      const control = resolveControlFromTarget(target);
      if (!control || !isSizeControl(control)) return;
      if (control.disabled) return;

      requestGalleryLockOnPosterSlide();
      beginSizeTransition();
    }

    scope.addEventListener(
      "pointerdown",
      function (event) {
        prepareSizeTransitionFromTarget(event.target);
      },
      true
    );

    scope.addEventListener(
      "keydown",
      function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        prepareSizeTransitionFromTarget(event.target);
      },
      true
    );

    /*
      This fallback keeps the full custom card clickable without clicking the
      radio twice. It does nothing when the browser has already selected it.
    */
    scope.addEventListener("click", function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const label = target.closest("label.ag-border-card");
      if (!label || !scope.contains(label)) return;

      let input = label.querySelector('input[type="radio"]');

      if (!input) {
        const inputId = label.getAttribute("for");
        if (inputId) {
          input = scope.querySelector(
            `[id="${inputId.replace(/(["\\])/g, "\\$1")}"]`
          );
        }
      }

      if (!input || input.disabled) return;

      /*
        Always return to the main thumbnail whenever Border / No Border is
        clicked, including when the clicked option is already selected.
      */
      if (isBorderControl(input)) {
        returnGalleryToMainThumbnail();
      }

      if (input.checked) return;

      /* Allow the native label action first. Only repair it in the next frame. */
      requestAnimationFrame(function () {
        if (input.checked) return;

        requestGalleryLockOnPosterSlide();
        input.checked = true;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    scope.addEventListener("change", function (event) {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches('input[type="radio"], select')) return;

      if (isBorderControl(event.target)) {
        returnGalleryToMainThumbnail();
        lastBorderInteractionAt = performance.now();
        gallery.classList.remove("ag-border-layout-syncing");
        lastStateKey = "";
        runUpdate(true);
      } else if (isSizeControl(event.target)) {
        requestGalleryLockOnPosterSlide();
        if (!sizeTransitionOverlay) beginSizeTransition();

        lastSizeInteractionAt = performance.now();
        gallery.classList.remove("ag-border-layout-syncing");
        lastStateKey = "";
        runUpdate(true);
        scheduleSizeTransitionRelease();
      } else if (isFrameControl(event.target)) {
        requestGalleryLockOnPosterSlide();
        gallery.classList.remove("ag-border-layout-syncing");
        lastStateKey = "";
        runUpdate(true);
      } else {
        settleLayout();
      }
    });

    function handleVariantUpdate() {
      lastStateKey = "";

      const recentSizeInteraction =
        performance.now() - lastSizeInteractionAt < 1400;

      if (sizeTransitionOverlay || recentSizeInteraction) {
        gallery.classList.remove("ag-border-layout-syncing");
        runUpdate(true);
        scheduleSizeTransitionRelease();
      } else if (performance.now() - lastBorderInteractionAt < 850) {
        gallery.classList.remove("ag-border-layout-syncing");
        returnGalleryToMainThumbnail();
        runUpdate(true);
      } else {
        settleLayout();
      }
    }

    document.addEventListener("variant:change", handleVariantUpdate);
    document.addEventListener("variant-change", handleVariantUpdate);

    window.addEventListener("resize", function () {
      cancelAnimationFrame(resizeFrame);
      removeSizeTransitionOverlay(true);
      resizeFrame = requestAnimationFrame(settleLayout);
    });

    /*
      Watch only gallery node replacement. Attribute changes are handled by
      ResizeObserver and by the stable-source code in the gallery snippet.
    */
    galleryObserver = new MutationObserver(function (mutations) {
      const galleryContentChanged = mutations.some(function (mutation) {
        if (mutation.type !== "childList") return false;

        const changedNodes = Array.from(mutation.addedNodes).concat(
          Array.from(mutation.removedNodes)
        );

        return changedNodes.some(function (node) {
          return !(
            node instanceof Element &&
            (
              node.classList.contains("ag-size-change-freeze") ||
              node.classList.contains("ag-real-border-swap-image")
            )
          );
        });
      });

      if (!galleryContentChanged) return;

      lastStateKey = "";

      if (
        sizeTransitionOverlay ||
        performance.now() - lastSizeInteractionAt < 1400
      ) {
        gallery.classList.remove("ag-border-layout-syncing");
        runUpdate(true);
        scheduleSizeTransitionRelease();
      } else {
        settleLayout();
      }
    });

    galleryObserver.observe(gallery, {
      childList: true,
      subtree: true
    });

    updateOptionUi();
    gallery.classList.add("ag-border-layout-syncing");
    applyPreview(true);
    enableTransitionsAfterInitialPaint();
    settleLayout();
  }

  function initializeAllGalleries() {
    ensureStyles();
    document.querySelectorAll(GALLERY_SELECTOR).forEach(initializeGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAllGalleries, {
      once: true
    });
  } else {
    initializeAllGalleries();
  }

  document.addEventListener("shopify:section:load", initializeAllGalleries);
})();
















// Frame Selection

document.addEventListener("DOMContentLoaded", function () {
  const frames = {
    black: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Black.png",
    svart: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Black.png",
    sort: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Black.png",

    white: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_White.png",
    vit: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_White.png",
    hvit: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_White.png",
    hvid: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_White.png",

    oak: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Oak.png",
    ek: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Oak.png",
    eik: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Oak.png",
    eg: "https://cdn.shopify.com/s/files/1/0790/7488/5861/files/Frame_Oak.png"
  };

  const NO_FRAME_VALUES = [
    "no frame",
    "no frames",
    "ingen ram",
    "ingen ramme",
    "utan ram",
    "without frame",
    "without frames",
    "unframed",
    "print only",
    "poster only",
    "none",
    "ingen"
  ];

  const SIZE_TO_FRAME_ADDON_CENTS = {
    "21x30": 7900,
    "21x30 cm": 7900,
    "30x40": 12900,
    "30x40 cm": 12900,
    "40x50": 18900,
    "40x50 cm": 18900,
    "50x70": 24900,
    "50x70 cm": 24900,
    "70x100": 38900,
    "70x100 cm": 38900
  };

  let syncFrameRaf;
  let resizeTimer;
  let frameRemovalTimer;
  const preloadedFrameImages = [];

  const FRAME_TRANSITION_MS = 220;

  function preloadFrameImages() {
    const uniqueUrls = Array.from(new Set(Object.values(frames)));

    uniqueUrls.forEach(function (url) {
      if (!url) return;

      const image = new Image();
      image.decoding = "async";
      image.src = url;
      preloadedFrameImages.push(image);
    });
  }

  /*
    IMPORTANT:
    Do not force width/height on .frame-wrapper or its image. The theme's
    product-thumbnail markup already controls the gallery aspect ratio.
    Forcing height: 100% or height: auto here can collapse the active Splide
    item and leave only the grey gallery background visible.
  */
  function removeOldFrameSizingStyles() {
    [
      "ag-frame-same-outer-size-styles-v2",
      "ag-frame-same-outer-size-styles-v3",
      "ag-frame-same-outer-size-styles-v4",
      "ag-frame-same-outer-size-styles-v5"
    ].forEach(function (styleId) {
      const oldStyle = document.getElementById(styleId);
      if (oldStyle) oldStyle.remove();
    });
  }

  function restoreNativeGallerySizing(wrapper) {
    if (!wrapper) return;

    /*
      Remove only the sizing/visibility properties added by the previous frame
      script. Border properties are deliberately kept because they are managed
      by applyFrame/clearFrame below.
    */
    [
      "width",
      "height",
      "min-width",
      "min-height",
      "max-width",
      "max-height",
      "aspect-ratio",
      "display",
      "opacity",
      "visibility",
      "overflow",
      "transform",
      "margin",
      "padding"
    ].forEach(function (property) {
      wrapper.style.removeProperty(property);
    });

    wrapper.style.setProperty("box-sizing", "border-box", "important");
    wrapper.style.setProperty(
      "transition",
      `border-top-width ${FRAME_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1), ` +
        `border-right-width ${FRAME_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1), ` +
        `border-bottom-width ${FRAME_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1), ` +
        `border-left-width ${FRAME_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1)`,
      "important"
    );
  }

  function normalizeValue(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ");
  }

  function isNoFrameValue(value) {
    return NO_FRAME_VALUES.includes(normalizeValue(value));
  }

  function getFrameWidth() {
    return window.matchMedia("(max-width: 768px)").matches ? 10 : 15;
  }

  function extractSizeKey(raw) {
    const value = normalizeValue(raw).replace(/×/g, "x");
    const match = value.match(/(\d+)\s*x\s*(\d+)/);
    if (!match) return "";
    return `${match[1]}x${match[2]}`;
  }

  function formatMoneyFromCents(cents) {
    const amount = Math.round((Number(cents) || 0) / 100);
    return `${new Intl.NumberFormat("sv-SE").format(amount)} kr`;
  }

  function getVariantRoot() {
    return document.querySelector('[id^="variant-selects-"]') || document;
  }

  function getSectionScope() {
    const root = getVariantRoot();

    if (root instanceof Element) {
      return root.closest(".shopify-section") || document;
    }

    return document;
  }

  function getGallery() {
    return document.querySelector('[id^="MediaGallery-"]');
  }

  function getBaseFrameWrapper() {
    const gallery = getGallery();
    if (!gallery) return null;

    return (
      gallery.querySelector('[data-border-base-slide="true"] .frame-wrapper') ||
      gallery.querySelector(".splide__slide.is-active .frame-wrapper") ||
      gallery.querySelector(".frame-wrapper")
    );
  }

  function getLabelForInput(root, input) {
    if (!input) return null;

    const wrappedLabel = input.closest("label");
    if (wrappedLabel) return wrappedLabel;

    if (input.id) {
      try {
        return root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      } catch (error) {
        return root.querySelector(`label[for="${input.id}"]`);
      }
    }

    return null;
  }

  function clearFrame(wrapper) {
    if (!wrapper) return;

    const nextState = "none";

    /*
      Remove the shadow whenever no frame is selected.
    */
    wrapper.style.setProperty("box-shadow", "none", "important");

    if (wrapper.dataset.agAppliedFrameState === nextState) {
      return;
    }

    window.clearTimeout(frameRemovalTimer);

    wrapper.dataset.agAppliedFrameState = nextState;
    wrapper.style.setProperty("border-style", "solid", "important");
    wrapper.style.setProperty("border-color", "transparent", "important");
    wrapper.style.setProperty("border-width", "0px", "important");
    wrapper.style.removeProperty("--ag-active-frame-width");
    wrapper.removeAttribute("data-ag-frame-value");
    wrapper.classList.remove("has-frame");

    /*
      Keep the current border image during the short width animation. Removing
      it immediately would make the frame flash off before the border has
      smoothly closed.
    */
    frameRemovalTimer = window.setTimeout(function () {
      if (
        wrapper &&
        document.documentElement.contains(wrapper) &&
        wrapper.dataset.agAppliedFrameState === nextState
      ) {
        wrapper.style.setProperty("border-image", "none", "important");
      }
    }, FRAME_TRANSITION_MS + 30);
  }

  function applyFrame(wrapper, value) {
    if (!wrapper) return;

    const key = normalizeValue(value);

    if (!key || isNoFrameValue(key)) {
      clearFrame(wrapper);
      return;
    }

    const frameUrl = frames[key];

    if (!frameUrl) {
      clearFrame(wrapper);
      return;
    }

    const frameWidth = getFrameWidth();
    const nextState = `${key}|${frameWidth}`;

    /*
      Apply the requested drop shadow only when a frame is selected.
    */
    wrapper.style.setProperty(
      "box-shadow",
      "1px 2px 3px #1d1f1e38",
      "important"
    );

    /*
      Shopify can emit several change and mutation events for one selection.
      Do not reapply the same frame because restarting the same border update
      was the source of the blinking effect.
    */
    if (wrapper.dataset.agAppliedFrameState === nextState) {
      return;
    }

    window.clearTimeout(frameRemovalTimer);

    const currentWidth =
      parseFloat(window.getComputedStyle(wrapper).borderTopWidth) || 0;

    wrapper.dataset.agAppliedFrameState = nextState;
    wrapper.setAttribute("data-ag-frame-value", key);
    wrapper.classList.add("has-frame");

    /*
      Keep the existing frame implementation and dimensions unchanged. Only
      animate the real border width from 0 to the normal 15px/10px value, so
      the poster settles smoothly inside the frame instead of blinking.
    */
    wrapper.style.setProperty("border-style", "solid", "important");
    wrapper.style.setProperty("border-color", "transparent", "important");
    wrapper.style.setProperty(
      "border-image",
      `url("${frameUrl}") 30 / ${frameWidth}px / 0 round`,
      "important"
    );
    wrapper.style.setProperty(
      "--ag-active-frame-width",
      `${frameWidth}px`
    );

    if (currentWidth <= 0.5) {
      wrapper.style.setProperty("border-width", "0px", "important");

      /*
        Commit the zero-width starting state before expanding the frame.
        Two animation frames prevent the browser from combining both values
        into one paint, which otherwise looks like a flash.
      */
      void wrapper.offsetWidth;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (
            wrapper &&
            document.documentElement.contains(wrapper) &&
            wrapper.dataset.agAppliedFrameState === nextState
          ) {
            wrapper.style.setProperty(
              "border-width",
              `${frameWidth}px`,
              "important"
            );
          }
        });
      });
    } else {
      wrapper.style.setProperty(
        "border-width",
        `${frameWidth}px`,
        "important"
      );
    }
  }

  function getOptionContainers(root) {
    return Array.from(root.children).filter((node) => {
      return (
        node.nodeType === 1 &&
        node.matches(".product-form__input, fieldset.product-form__input")
      );
    });
  }

  function getSelectedValueFromContainer(container) {
    if (!container) return "";

    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || "";

    const select = container.querySelector("select");
    if (select) return select.value || "";

    return "";
  }

  function getSelectedOptionValues() {
    const root = getVariantRoot();
    const containers = getOptionContainers(root);
    return containers.map(getSelectedValueFromContainer).filter(Boolean);
  }

  function getVariantsData() {
    const root = getVariantRoot();
    const script = root.querySelector('script[type="application/json"]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function getMatchedVariant() {
    const variants = getVariantsData();
    const selectedValues = getSelectedOptionValues().map(normalizeValue);

    if (!variants.length || !selectedValues.length) return null;

    return (
      variants.find((variant) => {
        const variantOptions = [variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .map(normalizeValue);

        if (variantOptions.length !== selectedValues.length) return false;

        return variantOptions.every((value, index) => value === selectedValues[index]);
      }) || null
    );
  }

  function getSelectedFrameValue() {
    const root = getVariantRoot();
    const frameField = root.querySelector('[data-option-role="frame"]');

    if (frameField) {
      const checked = frameField.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      const select = frameField.querySelector("select");
      if (select) return select.value;
    }

    return "";
  }

  function getSelectedSizeKey() {
    const root = getVariantRoot();
    const sizeField = root.querySelector('[data-option-role="size"]');

    if (sizeField) {
      const checked = sizeField.querySelector('input[type="radio"]:checked');
      if (checked) {
        const candidates = [
          checked.value,
          checked.getAttribute("aria-label"),
          checked.dataset.optionValue
        ];

        const label = getLabelForInput(root, checked);
        if (label) candidates.push(label.textContent);

        for (const candidate of candidates) {
          const key = extractSizeKey(candidate);
          if (SIZE_TO_FRAME_ADDON_CENTS[key] !== undefined) return key;
        }
      }

      const select = sizeField.querySelector("select");
      if (select) {
        const option = select.options[select.selectedIndex];
        const candidates = [
          select.value,
          option ? option.value : "",
          option ? option.textContent : ""
        ];

        for (const candidate of candidates) {
          const key = extractSizeKey(candidate);
          if (SIZE_TO_FRAME_ADDON_CENTS[key] !== undefined) return key;
        }
      }
    }

    const matchedVariant = getMatchedVariant();
    if (matchedVariant) {
      const candidates = [matchedVariant.option1, matchedVariant.option2, matchedVariant.option3];
      for (const candidate of candidates) {
        const key = extractSizeKey(candidate);
        if (SIZE_TO_FRAME_ADDON_CENTS[key] !== undefined) return key;
      }
    }

    return "";
  }

  function updateFramePriceHeading() {
    const selectedFrameValue = getSelectedFrameValue();
    const root = getVariantRoot();
    const labels = root.querySelectorAll("[data-frame-price-label]");

    labels.forEach((label) => {
      if (isNoFrameValue(selectedFrameValue)) {
        label.textContent = "+0 kr";
        label.classList.remove("is-empty");
        return;
      }

      const sizeKey = getSelectedSizeKey();
      const addon = SIZE_TO_FRAME_ADDON_CENTS[sizeKey] || 0;

      label.textContent = addon > 0 ? `+${formatMoneyFromCents(addon)}` : "";
      label.classList.toggle("is-empty", addon <= 0);
    });
  }

  function updateVisibleProductPrice() {
    const section = getSectionScope();
    const matchedVariant = getMatchedVariant();
    if (!matchedVariant) return;

    const formatted = formatMoneyFromCents(matchedVariant.price || 0);

    const selectors = [
      ".product__info-container .price-item--regular",
      ".product__info-container .price__sale .price-item--sale",
      ".product__info-container .price-item--sale",
      '.product__info-container [id^="price-"] .price-item--regular',
      '.product__info-container [id^="price-"] .price-item--sale',
      ".product__info-container .price__regular .price-item--regular",
      ".sticky-cart .price-item--regular",
      ".sticky-cart .price-item--sale",
      ".product-form-sticky .price-item--regular",
      ".product-form-sticky .price-item--sale"
    ];

    const seen = new Set();
    const priceNodes = [];

    selectors.forEach((selector) => {
      section.querySelectorAll(selector).forEach((node) => {
        if (!seen.has(node)) {
          seen.add(node);
          priceNodes.push(node);
        }
      });
    });

    priceNodes.forEach((node) => {
      node.textContent = formatted;
    });
  }

  function syncFrameAndPrice() {
    removeOldFrameSizingStyles();

    const wrapper = getBaseFrameWrapper();
    restoreNativeGallerySizing(wrapper);

    applyFrame(wrapper, getSelectedFrameValue());
    updateFramePriceHeading();
    updateVisibleProductPrice();
  }

  function queueFrameSync() {
    cancelAnimationFrame(syncFrameRaf);
    syncFrameRaf = requestAnimationFrame(syncFrameAndPrice);
  }

  document.addEventListener("change", function (e) {
    if (
      e.target instanceof Element &&
      e.target.matches('input[type="radio"], select')
    ) {
      queueFrameSync();
      setTimeout(queueFrameSync, 80);
      setTimeout(queueFrameSync, 250);
    }
  });

  document.addEventListener("click", function (e) {
    if (
      e.target instanceof Element &&
      e.target.closest('[data-option-role="frame"] label, [data-option-role="frame"] input')
    ) {
      setTimeout(queueFrameSync, 0);
      setTimeout(queueFrameSync, 80);
      setTimeout(queueFrameSync, 250);
    }
  });

  document.addEventListener("variant:change", function () {
    setTimeout(queueFrameSync, 50);
    setTimeout(queueFrameSync, 250);
    setTimeout(queueFrameSync, 500);
  });

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(queueFrameSync, 120);
  });

  const variantRoot = getVariantRoot();
  if (variantRoot instanceof Element) {
    const observer = new MutationObserver(function () {
      queueFrameSync();
    });

    observer.observe(variantRoot, {
      childList: true,
      subtree: true
    });
  }

  const gallery = getGallery();
  if (gallery) {
    const galleryObserver = new MutationObserver(function () {
      queueFrameSync();
    });

    galleryObserver.observe(gallery, {
      childList: true,
      subtree: true
    });
  }

  removeOldFrameSizingStyles();
  preloadFrameImages();
  window.addEventListener("load", queueFrameSync);

  setTimeout(queueFrameSync, 100);
  setTimeout(queueFrameSync, 300);
  setTimeout(queueFrameSync, 600);
  setTimeout(queueFrameSync, 900);

  queueFrameSync();
});













// Default Values on Reload



document.addEventListener("DOMContentLoaded", function () {
  const url = new URL(window.location.href);

  if (url.searchParams.has("variant")) {
    url.searchParams.delete("variant");
    window.history.replaceState({}, document.title, url.toString());
  }

  const gallery = document.querySelector('[id^="MediaGallery-"]');
  const scope = gallery ? (gallery.closest('.shopify-section') || document) : document;
  const mediaContainer =
    scope.querySelector('.product-media-container') ||
    document.querySelector('.product-media-container');

  if (!mediaContainer) return;

  const hasRealBorderImages = !!scope.querySelector('[id^="BorderSwapData-"]');

  // Hide media while resetting options to avoid flicker / jerk
  mediaContainer.classList.add('is-initializing-media');

  function resetVariantInputsToDefault() {
    const variantRadios = scope.querySelectorAll('variant-selects input[type="radio"]');
    const firstCheckedPerGroup = {};
    const radiosToTrigger = [];

    variantRadios.forEach((radio) => {
      const name = radio.name;

      if (!firstCheckedPerGroup[name]) {
        radio.checked = true;
        firstCheckedPerGroup[name] = radio;
      } else {
        radio.checked = false;
      }
    });

    Object.values(firstCheckedPerGroup).forEach((radio) => {
      radiosToTrigger.push(radio);
    });

    const variantSelects = scope.querySelectorAll('variant-selects select');
    variantSelects.forEach((select) => {
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    radiosToTrigger.forEach((radio) => {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getBorderValue() {
    const checkedRadio = scope.querySelector(
      'input[type="radio"][name*="Border"]:checked, input[type="radio"][name*="border"]:checked'
    );
    if (checkedRadio) return (checkedRadio.value || '').trim().toLowerCase();

    const borderSelect = scope.querySelector(
      'select[name*="Border"], select[name*="border"]'
    );
    if (borderSelect) return (borderSelect.value || '').trim().toLowerCase();

    return '';
  }

  function updatePaddingMode() {
    if (hasRealBorderImages) {
      mediaContainer.classList.remove('border-active', 'use-code-padding', 'no-border-active');
      return;
    }

    mediaContainer.classList.add('use-code-padding');

    const borderValue = getBorderValue();
    const isBorder = borderValue === 'border';

    if (isBorder) {
      mediaContainer.classList.add('border-active');
      mediaContainer.classList.remove('no-border-active');
    } else {
      mediaContainer.classList.remove('border-active');
      mediaContainer.classList.add('no-border-active');
    }
  }

  resetVariantInputsToDefault();
  updatePaddingMode();

  // Show media only after reset + theme updates are done
  setTimeout(() => {
    mediaContainer.classList.remove('is-initializing-media');
  }, 180);

  scope.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"], select')) {
      updatePaddingMode();
    }
  });

  document.addEventListener('variant:change', function () {
    updatePaddingMode();
  });
});



















document.addEventListener("click", function (e) {
  const icon = e.target.closest(".custom-wishlist-icon");
  if (!icon) return;

  e.preventDefault();
  e.stopPropagation();

  const productId = icon.dataset.productId;

  // Toggle wishlist
  toggleWishlist(productId);

  // Update icon src
  const filled = isInWishlist(productId);
  icon.setAttribute("src", filled ? FILLED_ICON : EMPTY_ICON);

  // Add animation
  icon.classList.add("pop");
  if (filled) icon.classList.add("filled");
  else icon.classList.remove("filled");

  // Remove pop class after animation
  setTimeout(() => icon.classList.remove("pop"), 200);
});

















  (function () {
    if (window.__AGWishlistHeaderBadgeFix) return;
    window.__AGWishlistHeaderBadgeFix = true;

    var WISHLIST_KEY = 'wishlist_products';

    function getWishlist() {
      try {
        var items = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
        return Array.isArray(items) ? items : [];
      } catch (e) {
        return [];
      }
    }

    function getWishlistLink() {
      return (
        document.querySelector('.header__icon--wishlist') ||
        document.querySelector('.header__icon-wishlist') ||
        document.querySelector('a[href*="/pages/wishlist"]')
      );
    }

    function ensureBadge() {
      var wishlistLink = getWishlistLink();
      if (!wishlistLink) return null;

      var badge = wishlistLink.querySelector('.wishlist-count-badge');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wishlist-count-badge is-hidden';
        wishlistLink.appendChild(badge);
      }

      return badge;
    }

    function updateWishlistBadge() {
      var badge = ensureBadge();
      if (!badge) return;

      var count = getWishlist().length;

      if (count > 0) {
        badge.textContent = count;
        badge.setAttribute('data-count', count);
        badge.classList.remove('is-hidden');
        badge.style.display = 'inline-flex';
      } else {
        badge.textContent = '';
        badge.setAttribute('data-count', '0');
        badge.classList.add('is-hidden');
        badge.style.display = 'none';
      }
    }

    document.addEventListener('DOMContentLoaded', updateWishlistBadge);
    window.addEventListener('load', updateWishlistBadge);
    window.addEventListener('pageshow', updateWishlistBadge);

    document.addEventListener('wishlist:updated', updateWishlistBadge);

    window.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) {
        updateWishlistBadge();
      }
    });

    setTimeout(updateWishlistBadge, 100);
    setTimeout(updateWishlistBadge, 500);
    setTimeout(updateWishlistBadge, 1000);

    window.updateWishlistBadge = updateWishlistBadge;
  })();

















